// Proposed reviewed edition data. Raw author returns and previous editions remain preserved.
export const reviewedActingGuidanceEditions = {
  "family-paper-bridge-v1": {
    "storyId": "family-paper-bridge-v1",
    "approvalStatus": "OWNER_ADOPTED_AFTER_INDEPENDENT_REVIEW",
    "beforeCatalogRevision": 3,
    "expectedCount": 149,
    "sourceDraftSha256": "344157aea7259c3de7e1afd3bbe32117ec29e03b6e719006e9e9314a624bd055",
    "sourceInputSha256": "72a3d6d109dfa8c23c07a709836fbdbcde8bbeec7ef2901877b91bf3325404d8",
    "ownerFidelityChoices": {},
    "rows": [
      {
        "cueId": "paper-expanded-c005",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "We are not doing last year again.",
        "sourceDirectionText": null,
        "fullDirectionText": "Set a firm boundary without raising your voice. Let Ada's concern about repeating last year give the words weight.",
        "spokenDirectionText": "Firmly set boundaries",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c006",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "I was not here last year.",
        "sourceDirectionText": null,
        "fullDirectionText": "Answer plainly, with a hint of confusion. Ben is only explaining that he was not there and does not know what happened.",
        "spokenDirectionText": "Matter-of-fact, puzzled",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c007",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Exactly. Fresh start. No long meetings.",
        "sourceDirectionText": null,
        "fullDirectionText": "Seize on Ben's answer as proof of a fresh start. Pick up the pace on the last sentence, eager to keep the group moving.",
        "spokenDirectionText": "Quick, upbeat resolve",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c008",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "I was going to read the rules.",
        "sourceDirectionText": null,
        "fullDirectionText": "Gently interrupt her rush with a reasonable objection. Ben wants to read the rules before they skip ahead.",
        "spokenDirectionText": "Calm, reasonable objection",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c009",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "I just summarized them.",
        "sourceDirectionText": null,
        "fullDirectionText": "Reply with brisk confidence, as though the matter is already settled. Let the humor come from how certain Ada is.",
        "spokenDirectionText": "Brisk, confident reply",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c010",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "You summarized your feelings about the rules.",
        "sourceDirectionText": null,
        "fullDirectionText": "Tease Ada's rule summary without sounding cruel; Ben wants the actual rules to matter.",
        "spokenDirectionText": "Dry teasing",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c011",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Bridge. Gap. Cart crosses. Done.",
        "sourceDirectionText": null,
        "fullDirectionText": "Rattle off the three steps as if naming them makes the bridge simple.",
        "spokenDirectionText": "Speed through plan",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c013",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "That center is already dipping.",
        "sourceDirectionText": null,
        "fullDirectionText": "Focus on the dipping center and warn Ada before they add more weight.",
        "spokenDirectionText": "Spot the sag",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c014",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "It is paper. Paper bends.",
        "sourceDirectionText": null,
        "fullDirectionText": "Treat the bend as ordinary, trying to keep Ben from slowing the build.",
        "spokenDirectionText": "Dismiss concern",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c015",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Bridges usually try not to.",
        "sourceDirectionText": null,
        "fullDirectionText": "Answer her paper defense with dry humor, eyes still on the bending bridge.",
        "spokenDirectionText": "Deadpan warning",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c016",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Hand me the tape.",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask for tape as an immediate practical command, already thinking about the next fix.",
        "spokenDirectionText": "Take charge",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c018",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Small piece or big piece?",
        "sourceDirectionText": null,
        "fullDirectionText": "Offer the two tape sizes precisely because the amount matters.",
        "spokenDirectionText": "Clarify carefully",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c019",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Big.",
        "sourceDirectionText": null,
        "fullDirectionText": "Choose the biggest piece without stopping to calculate supplies.",
        "spokenDirectionText": "Decide instantly",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c020",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "We do not have much.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point out the shortage as a real limit, not a complaint.",
        "spokenDirectionText": "Guard supplies",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c021",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Then medium-big.",
        "sourceDirectionText": null,
        "fullDirectionText": "Quickly revise your demand, confident your made-up size makes sense.",
        "spokenDirectionText": "Invent a compromise",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c022",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "That is not a size.",
        "sourceDirectionText": null,
        "fullDirectionText": "Object plainly to the invented measurement while still offering help.",
        "spokenDirectionText": "Challenge the label",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c023",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "It is now.",
        "sourceDirectionText": null,
        "fullDirectionText": "Claim your new size as if it were obvious, a quick flash of humor.",
        "spokenDirectionText": "Playful certainty",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c026",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "That corner is pulling.",
        "sourceDirectionText": null,
        "fullDirectionText": "Watch the stressed corner and draw attention to the movement.",
        "spokenDirectionText": "Notice the pull",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c027",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "It is fine.",
        "sourceDirectionText": null,
        "fullDirectionText": "Assure Ben too quickly, unwilling to stop building.",
        "spokenDirectionText": "Brush it off",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c028",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "It is pulling right now.",
        "sourceDirectionText": null,
        "fullDirectionText": "Try to draw Ada’s attention to the corner pulling right now. Keep the urgency in your words; she may choose to keep building.",
        "spokenDirectionText": "Insist on evidence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c030",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Put another sheet under this side.",
        "sourceDirectionText": null,
        "fullDirectionText": "Give one clear instruction, using another sheet to support the weak side.",
        "spokenDirectionText": "Direct the repair",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c031",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "That makes one side thicker.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point out the added thickness on only one side as a warning.",
        "spokenDirectionText": "Explain imbalance",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c032",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "We will thicken the other side.",
        "sourceDirectionText": null,
        "fullDirectionText": "Offer a matching change as a straightforward solution to Ben's concern.",
        "spokenDirectionText": "Double down",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c033",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "With what?",
        "sourceDirectionText": null,
        "fullDirectionText": "Make her account for what material is left before promising more support.",
        "spokenDirectionText": "Ask pointedly",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c034",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "More paper.",
        "sourceDirectionText": null,
        "fullDirectionText": "Answer as if more paper is the only reasonable solution.",
        "spokenDirectionText": "State the obvious",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c035",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Strong plan. Keep using paper until the paper problem goes away.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let the absurdity of endless paper do the work; Ben is still invested in helping.",
        "spokenDirectionText": "Dry sarcasm",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c036",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Are you helping?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask whether he is helping because you feel him resisting every quick fix.",
        "spokenDirectionText": "Challenge Ben",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c037",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "I am literally holding the bridge.",
        "sourceDirectionText": null,
        "fullDirectionText": "Keep holding the bridge as you say this, frustration grounded in the effort.",
        "spokenDirectionText": "Assert your effort",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c039",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Cart.",
        "sourceDirectionText": null,
        "fullDirectionText": "Call for the next object briskly, ready to see the bridge work.",
        "spokenDirectionText": "Demand the cart",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c040",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "We are testing already?",
        "sourceDirectionText": null,
        "fullDirectionText": "Look at the unfinished bridge, surprised Ada wants a test now.",
        "spokenDirectionText": "Question the timing",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c041",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-1",
        "sourceDialogueText": "Tiny test.",
        "sourceDirectionText": null,
        "fullDirectionText": "Pitch this as a harmless little trial despite Ben's concern.",
        "spokenDirectionText": "Minimize the risk",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c043",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "The wheel is crooked.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point toward the wheel before the cart moves farther.",
        "spokenDirectionText": "Notice crooked wheel",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c044",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "The bridge is straight.",
        "sourceDirectionText": null,
        "fullDirectionText": "Separate the bridge from the cart problem with immediate certainty.",
        "spokenDirectionText": "Defend the bridge",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c045",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "Those are separate facts.",
        "sourceDirectionText": null,
        "fullDirectionText": "State that both observations can be true, without surrendering the wheel concern.",
        "spokenDirectionText": "Dry correction",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c046",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "Ready?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask for confirmation while already poised to start.",
        "spokenDirectionText": "Push for readiness",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c047",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "No.",
        "sourceDirectionText": null,
        "fullDirectionText": "Say no without dressing it up; Ben is not ready.",
        "spokenDirectionText": "Flat refusal",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c048",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "Good enough.",
        "sourceDirectionText": null,
        "fullDirectionText": "Treat his no as close enough and keep the experiment moving.",
        "spokenDirectionText": "Override hesitation",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c051",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "Stop.",
        "sourceDirectionText": null,
        "fullDirectionText": "Cut in sharply as the moving cart threatens the test.",
        "spokenDirectionText": "Urgent stop",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c052",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "It is still up.",
        "sourceDirectionText": null,
        "fullDirectionText": "Focus on the fact that the bridge still stands rather than Ben's warning.",
        "spokenDirectionText": "Cling to success",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c053",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "Stop the cart.",
        "sourceDirectionText": null,
        "fullDirectionText": "Make the danger specific and immediate; he needs her to stop the moving cart.",
        "spokenDirectionText": "Stop the cart",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c056",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "Okay. Back.",
        "sourceDirectionText": null,
        "fullDirectionText": "Finally give ground and reverse the test with a short command.",
        "spokenDirectionText": "Pull back",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c058",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "That was not a tiny test.",
        "sourceDirectionText": null,
        "fullDirectionText": "Remind Ada the supposedly tiny test was anything but tiny.",
        "spokenDirectionText": "Correct the claim",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c059",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "It almost worked.",
        "sourceDirectionText": null,
        "fullDirectionText": "Hold onto how close it came to working, despite the failure.",
        "spokenDirectionText": "Defend the attempt",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c060",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "The middle folded.",
        "sourceDirectionText": null,
        "fullDirectionText": "Identify the folded middle in plain physical terms, not blame.",
        "spokenDirectionText": "Name the failure",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c061",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "So we fix the middle.",
        "sourceDirectionText": null,
        "fullDirectionText": "Turn quickly from the failure toward a repair.",
        "spokenDirectionText": "Move to fixing",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c062",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "Before we fix it, look at what dropped first.",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask Ada to observe the first failure before touching the bridge again.",
        "spokenDirectionText": "Slow her down",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c064",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "Center sank first.",
        "sourceDirectionText": null,
        "fullDirectionText": "Report the sag honestly after taking a real look.",
        "spokenDirectionText": "Acknowledge center",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c065",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "And then?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask for the next event, guiding Ada through the evidence.",
        "spokenDirectionText": "Prompt the sequence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c066",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "The cart pulled left.",
        "sourceDirectionText": null,
        "fullDirectionText": "Describe the cart's leftward pull as the next event.",
        "spokenDirectionText": "Follow the movement",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c067",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "Two problems.",
        "sourceDirectionText": null,
        "fullDirectionText": "State the number clearly so the issues stay separate.",
        "spokenDirectionText": "Count the problems",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c068",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "One bridge.",
        "sourceDirectionText": null,
        "fullDirectionText": "Reduce Ben's list to the one bridge you want fixed.",
        "spokenDirectionText": "Push for unity",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c069",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "Still two problems.",
        "sourceDirectionText": null,
        "fullDirectionText": "Calmly insist the two problems still need separate attention.",
        "spokenDirectionText": "Hold the distinction",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c070",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-2",
        "sourceDialogueText": "Fine. Middle first.",
        "sourceDirectionText": null,
        "fullDirectionText": "Concede the point and commit to repairing the middle first.",
        "spokenDirectionText": "Accept the order",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c072",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "That is our one clean backup.",
        "sourceDirectionText": null,
        "fullDirectionText": "Warn Ada that the strip marked SPARE SUPPORT is their one clean backup. Treat its limited supply as the concern.",
        "spokenDirectionText": "Protect the backup",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c073",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "That is why it is called backup.",
        "sourceDirectionText": null,
        "fullDirectionText": "Answer with quick resolve, willing to spend the backup now.",
        "spokenDirectionText": "Justify the choice",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c075",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Want to fold it before you put it under there?",
        "sourceDirectionText": null,
        "fullDirectionText": "Offer to fold the SPARE SUPPORT strip before Ada puts it beneath the bridge. Give her room to decide.",
        "spokenDirectionText": "Suggest folding support",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c076",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Folding takes time.",
        "sourceDirectionText": null,
        "fullDirectionText": "Resist folding because the clock is on your mind.",
        "spokenDirectionText": "Rush the decision",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c077",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Rebuilding takes more.",
        "sourceDirectionText": null,
        "fullDirectionText": "Counter with the time they would lose rebuilding yet again.",
        "spokenDirectionText": "Compare the costs",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c079",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "It is catching.",
        "sourceDirectionText": null,
        "fullDirectionText": "Warn Ada about the spare support catching on the wrinkled tape. Focus on the visible snag and the risk of tearing if it keeps moving; do not touch it.",
        "spokenDirectionText": "Warn of snag",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c080",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "I see it.",
        "sourceDirectionText": null,
        "fullDirectionText": "Acknowledge what Ben sees while looking for a way through.",
        "spokenDirectionText": "Admit the snag",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c081",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Stop pushing.",
        "sourceDirectionText": null,
        "fullDirectionText": "Tell her to quit pushing before the snag becomes a tear.",
        "spokenDirectionText": "Stop the push",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c082",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "It just needs to get past the wrinkle.",
        "sourceDirectionText": null,
        "fullDirectionText": "Downplay the wrinkle as a small obstacle, trying to convince Ben it can be dealt with.",
        "spokenDirectionText": "Minimize the snag",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c084",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Back it out.",
        "sourceDirectionText": null,
        "fullDirectionText": "Tell her to back the piece out before it is damaged.",
        "spokenDirectionText": "Order retreat",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c085",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "If I back it out, we lose the spot.",
        "sourceDirectionText": null,
        "fullDirectionText": "Explain why retreat feels costly even as the paper catches.",
        "spokenDirectionText": "Fear lost progress",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c086",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "We do not have a spot yet.",
        "sourceDirectionText": null,
        "fullDirectionText": "Remind her they have not reached a stable position worth saving.",
        "spokenDirectionText": "Reject false progress",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c090",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "No.",
        "sourceDirectionText": null,
        "fullDirectionText": "React to the failed attempt with a blunt, disappointed no.",
        "spokenDirectionText": "Immediate denial",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c092",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Tape.",
        "sourceDirectionText": null,
        "fullDirectionText": "Request tape urgently, already seeking a quick patch.",
        "spokenDirectionText": "Ask for tape",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c093",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "For the tear or the bridge?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask which part needs the tape so the fix stays targeted.",
        "spokenDirectionText": "Demand clarity",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c094",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Yes.",
        "sourceDirectionText": null,
        "fullDirectionText": "Claim both uses with comic impatience instead of choosing.",
        "spokenDirectionText": "Answer both",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c095",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "That was not one of the options.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point out that she avoided the actual question.",
        "spokenDirectionText": "Call out evasion",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c098",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "They are already testing.",
        "sourceDirectionText": null,
        "fullDirectionText": "Keep your eyes on your own bridge as instructed. Let the knowledge that another team is already testing put urgency in your voice without looking toward them.",
        "spokenDirectionText": "Feel the clock",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c099",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "We were already testing too.",
        "sourceDirectionText": null,
        "fullDirectionText": "Remind her their own tests have already begun, even if messy.",
        "spokenDirectionText": "Challenge comparison",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c100",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Not successfully.",
        "sourceDirectionText": null,
        "fullDirectionText": "Make the difference clear: their earlier runs did not succeed.",
        "spokenDirectionText": "Admit failure",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c102",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "That joint is going to twist.",
        "sourceDirectionText": null,
        "fullDirectionText": "Watch the joint and warn of the direction it will move.",
        "spokenDirectionText": "Predict twisting",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c103",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Then we tape the twist flat.",
        "sourceDirectionText": null,
        "fullDirectionText": "Try to solve the twist immediately with more tape.",
        "spokenDirectionText": "Propose quick tape",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c104",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "That is how we got here.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point out they tried that approach and it caused trouble.",
        "spokenDirectionText": "Remember the mistake",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c105",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "One more test.",
        "sourceDirectionText": null,
        "fullDirectionText": "Push for another run despite the warning.",
        "spokenDirectionText": "Demand one try",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c106",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Same bridge?",
        "sourceDirectionText": null,
        "fullDirectionText": "Look over the repaired structure and doubt that it has changed enough.",
        "spokenDirectionText": "Question the same bridge",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c107",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Better bridge.",
        "sourceDirectionText": null,
        "fullDirectionText": "Insist that this version deserves another chance.",
        "spokenDirectionText": "Sell the revision",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c108",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Heavier and crooked.",
        "sourceDirectionText": null,
        "fullDirectionText": "Name the added weight and crooked shape without exaggeration.",
        "spokenDirectionText": "List the flaws",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c109",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Reinforced.",
        "sourceDirectionText": null,
        "fullDirectionText": "Offer a single confident reason the extra material helps.",
        "spokenDirectionText": "Claim reinforcement",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c110",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-3",
        "sourceDialogueText": "Those can both be true.",
        "sourceDirectionText": null,
        "fullDirectionText": "Allow that the bridge is reinforced and badly shaped at once.",
        "spokenDirectionText": "Concede both facts",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c113",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "Look at the edges.",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask Ada to look along the edges rather than at the center alone.",
        "spokenDirectionText": "Direct attention outward",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c114",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "Left side is lower.",
        "sourceDirectionText": null,
        "fullDirectionText": "Notice and name the lowered left side carefully.",
        "spokenDirectionText": "Report the lean",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c115",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "And the cart pulls left.",
        "sourceDirectionText": null,
        "fullDirectionText": "Match the left lean to the cart's pull in the same direction.",
        "spokenDirectionText": "Connect the evidence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c116",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "I know.",
        "sourceDirectionText": null,
        "fullDirectionText": "Admit knowing the issue, frustrated at hearing it again.",
        "spokenDirectionText": "Resist repeated advice",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c118",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "We need one clean run.",
        "sourceDirectionText": null,
        "fullDirectionText": "Reveal how badly you want a single clean crossing.",
        "spokenDirectionText": "Ask for one success",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c119",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "We need one bridge that stays up.",
        "sourceDirectionText": null,
        "fullDirectionText": "Ground the goal in a bridge that stays up, not a lucky run.",
        "spokenDirectionText": "Demand stability",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c122",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "Actually tiny this time.",
        "sourceDirectionText": null,
        "fullDirectionText": "Stress actually tiny to show you heard the earlier objection.",
        "spokenDirectionText": "Promise smaller test",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c125",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "Hold it.",
        "sourceDirectionText": null,
        "fullDirectionText": "Give a brief instruction to halt the movement.",
        "spokenDirectionText": "Hold everything",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c126",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "I am stopping.",
        "sourceDirectionText": null,
        "fullDirectionText": "Say you are stopping and demonstrate it by going still.",
        "spokenDirectionText": "Confirm stopping",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c129",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "Wait.",
        "sourceDirectionText": null,
        "fullDirectionText": "Interrupt before another risky move with one clear word.",
        "spokenDirectionText": "Wait urgently",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c132",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "Did it break?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask whether the structure broke, afraid to look closely.",
        "spokenDirectionText": "Check the damage",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c133",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "Not all of it.",
        "sourceDirectionText": null,
        "fullDirectionText": "Report that some of it survived, without calling it a success.",
        "spokenDirectionText": "Answer carefully",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c135",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "I ruined it.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let the admission land quietly; Ada feels responsible for the damage.",
        "spokenDirectionText": "Own the mistake",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c136",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "You made it worse.",
        "sourceDirectionText": null,
        "fullDirectionText": "State the damage directly while keeping blame out of Ben's tone.",
        "spokenDirectionText": "Tell the truth",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c137",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "Thank you.",
        "sourceDirectionText": null,
        "fullDirectionText": "Respond as if his blunt comment stung, masking embarrassment.",
        "spokenDirectionText": "Bitter gratitude",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c138",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "That was not the end of the sentence.",
        "sourceDirectionText": null,
        "fullDirectionText": "Indicate that the thought is unfinished and ask Ada to hear the rest.",
        "spokenDirectionText": "Keep speaking",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c139",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "It felt complete.",
        "sourceDirectionText": null,
        "fullDirectionText": "Deflect the sting by pretending Ben's criticism was complete.",
        "spokenDirectionText": "Use dry humor",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c140",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "You made it worse. That does not mean you have to keep making it worse.",
        "sourceDirectionText": null,
        "fullDirectionText": "Finish the thought gently: making it worse does not require continuing.",
        "spokenDirectionText": "Offer a way forward",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c143",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "We have three minutes.",
        "sourceDirectionText": null,
        "fullDirectionText": "State the remaining time and let its pressure register.",
        "spokenDirectionText": "Count the minutes",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c144",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "Then we cannot afford another fast mistake.",
        "sourceDirectionText": null,
        "fullDirectionText": "Make a calm case that one more hasty error costs more than a pause.",
        "spokenDirectionText": "Reject another rush",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c145",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-4",
        "sourceDialogueText": "I do not know what to do.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let your pace slow as you finally say you do not know the next move.",
        "spokenDirectionText": "Admit uncertainty",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c146",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "Good.",
        "sourceDirectionText": null,
        "fullDirectionText": "Say good as an opening, not a put-down; Ben notices Ada has stopped.",
        "spokenDirectionText": "Welcome the pause",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c147",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "Good?",
        "sourceDirectionText": null,
        "fullDirectionText": "Show surprise that Ben welcomed your uncertainty.",
        "spokenDirectionText": "Question his reaction",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c148",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "You finally stopped long enough to say it.",
        "sourceDirectionText": null,
        "fullDirectionText": "Explain that admitting uncertainty means she can finally observe the problem.",
        "spokenDirectionText": "Name the breakthrough",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c150",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "Fine. I am looking.",
        "sourceDirectionText": null,
        "fullDirectionText": "Agree reluctantly, then look closely rather than grabbing supplies.",
        "spokenDirectionText": "Start observing",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c151",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "Start with what still works.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point her toward the pieces still holding, not only what failed.",
        "spokenDirectionText": "Find surviving strengths",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c152",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "The ends are still flat. The center is weak.",
        "sourceDirectionText": null,
        "fullDirectionText": "Take stock of the whole bridge, identifying both flat ends and the weak center. Give the weak middle its due weight without rushing into repair.",
        "spokenDirectionText": "Assess the structure",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c153",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "That helps.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let her know that specific observation is useful for a real fix.",
        "spokenDirectionText": "Encourage evidence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c154",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "The extra tape made the left side heavy.",
        "sourceDirectionText": null,
        "fullDirectionText": "Notice that extra tape made the left side heavy, without blaming Ben.",
        "spokenDirectionText": "Connect tape weight",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c155",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "Yep.",
        "sourceDirectionText": null,
        "fullDirectionText": "Confirm her observation without taking over the reasoning.",
        "spokenDirectionText": "Agree simply",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c156",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "Stop saying yep.",
        "sourceDirectionText": null,
        "fullDirectionText": "Your patience snaps at one more yep; keep it brief, not cruel.",
        "spokenDirectionText": "Ask him to stop",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c157",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "Noted.",
        "sourceDirectionText": null,
        "fullDirectionText": "Answer dryly and stop repeating the word.",
        "spokenDirectionText": "Honor the request",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c160",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "Do that again.",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask Ben to repeat the rule-card fold you just noticed. Direct your interest toward his demonstration rather than making the fold yourself.",
        "spokenDirectionText": "Ask Ben to repeat",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c162",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "It stays stiff.",
        "sourceDirectionText": null,
        "fullDirectionText": "Test the folded piece and describe the improved strength.",
        "spokenDirectionText": "Notice stiffness",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c163",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "More than when it is flat.",
        "sourceDirectionText": null,
        "fullDirectionText": "Compare Ben’s folded rule-card corner with the flat part of that same card. Let the stronger shape be the discovery.",
        "spokenDirectionText": "Compare card shapes",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c165",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "What do you see?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask Ben what he sees instead of proposing the answer yourself.",
        "spokenDirectionText": "Invite observation",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c167",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "Long fibers are still good on both pieces.",
        "sourceDirectionText": null,
        "fullDirectionText": "Inspect both pieces and report what remains usable.",
        "spokenDirectionText": "Identify good fibers",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c168",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "And if we fold them?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask whether the surviving fibers might work differently if folded.",
        "spokenDirectionText": "Explore folding",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c169",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "They might hold their shape.",
        "sourceDirectionText": null,
        "fullDirectionText": "Suggest they could keep their shape, leaving room to test it.",
        "spokenDirectionText": "Offer cautious hope",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c170",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "Two ribs.",
        "sourceDirectionText": null,
        "fullDirectionText": "Identify two ribs as the next possible structure.",
        "spokenDirectionText": "Plan two supports",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c171",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "Maybe.",
        "sourceDirectionText": null,
        "fullDirectionText": "Agree cautiously, wanting proof before another bold claim.",
        "spokenDirectionText": "Temper confidence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c172",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-5",
        "sourceDialogueText": "We fold first. Then tape.",
        "sourceDirectionText": null,
        "fullDirectionText": "Set the repair order clearly: fold first, then tape.",
        "spokenDirectionText": "Choose the sequence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c175",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "That is already better.",
        "sourceDirectionText": null,
        "fullDirectionText": "Recognize that the shape already works better before testing the cart.",
        "spokenDirectionText": "Notice improvement",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c176",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "Same paper. Different shape.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point out that the material is unchanged but the shape is different.",
        "spokenDirectionText": "State the insight",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c178",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "Hold it there.",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask Ada to hold the folded piece where it is so you can compare the two folds. Keep your own action a request.",
        "spokenDirectionText": "Ask Ada to hold",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c179",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "Why?",
        "sourceDirectionText": null,
        "fullDirectionText": "Question the stop instead of shifting the bridge.",
        "spokenDirectionText": "Ask for cause",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c180",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "The folds are not the same height.",
        "sourceDirectionText": null,
        "fullDirectionText": "Explain the mismatch in rib heights as a practical adjustment.",
        "spokenDirectionText": "Compare fold heights",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c182",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "Mine is tighter.",
        "sourceDirectionText": null,
        "fullDirectionText": "Observe that your own fold is tighter than Ben’s. Let uncertainty show while you compare, without arguing that it must stay that way.",
        "spokenDirectionText": "Notice tighter fold",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c183",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "Loosen it a little.",
        "sourceDirectionText": null,
        "fullDirectionText": "Recommend loosening slightly so the ribs can match.",
        "spokenDirectionText": "Suggest easing tension",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c184",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "That feels wrong.",
        "sourceDirectionText": null,
        "fullDirectionText": "Question the suggested adjustment to the fold. Let the change feel physically unfamiliar without making a larger claim about trust.",
        "spokenDirectionText": "Question the adjustment",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c185",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "So did the bridge leaning left.",
        "sourceDirectionText": null,
        "fullDirectionText": "Remind Ada that the bridge leaning left also felt wrong. Use the earlier lean as a fair comparison, not as proof that it was progress.",
        "spokenDirectionText": "Recall earlier lean",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c188",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "Do not tape yet.",
        "sourceDirectionText": null,
        "fullDirectionText": "Stop Ben before tape hides an adjustment they still need.",
        "spokenDirectionText": "Prevent early tape",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c189",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "I was not going to.",
        "sourceDirectionText": null,
        "fullDirectionText": "Respond calmly that you were already waiting.",
        "spokenDirectionText": "Stay patient",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c190",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "I know. I am practicing.",
        "sourceDirectionText": null,
        "fullDirectionText": "Admit you are practicing slowing down, not accusing Ben.",
        "spokenDirectionText": "Practice restraint",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c192",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "Left rib is too far in.",
        "sourceDirectionText": null,
        "fullDirectionText": "Identify exactly which support sits too far inward.",
        "spokenDirectionText": "Locate the left rib",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c193",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "Move it out a little.",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask Ben to move the left rib outward just a little, guiding his placement rather than sliding it yourself.",
        "spokenDirectionText": "Guide Ben outward",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c195",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "Stop. There.",
        "sourceDirectionText": null,
        "fullDirectionText": "Stop the adjustment as soon as the alignment looks right.",
        "spokenDirectionText": "Mark the position",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c197",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "That is less tape than before.",
        "sourceDirectionText": null,
        "fullDirectionText": "Notice how little tape they used this time.",
        "spokenDirectionText": "Count less tape",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c198",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-6",
        "sourceDialogueText": "I noticed.",
        "sourceDirectionText": null,
        "fullDirectionText": "Acknowledge the improvement without making a speech.",
        "spokenDirectionText": "Quiet satisfaction",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c201",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-7",
        "sourceDialogueText": "Small test.",
        "sourceDirectionText": null,
        "fullDirectionText": "Invite a measured test, remembering their earlier mistake.",
        "spokenDirectionText": "Propose small test",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c203",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-7",
        "sourceDialogueText": "Again.",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask Ada to press the center once more so you can see whether the ribs hold. Do not perform her press.",
        "spokenDirectionText": "Ask for another press",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c205",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-7",
        "sourceDialogueText": "Bring the cart.",
        "sourceDirectionText": null,
        "fullDirectionText": "Call to Ben to bring the blue cart for the next test. Remain where you are and let Ben set its wheels on the bridge.",
        "spokenDirectionText": "Call for the cart",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c208",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-7",
        "sourceDialogueText": "Still level.",
        "sourceDirectionText": null,
        "fullDirectionText": "Observe that the structure remains even under the test.",
        "spokenDirectionText": "Watch the level",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c209",
        "characterId": "ben",
        "sceneId": "paper-expanded-scene-7",
        "sourceDialogueText": "Slow.",
        "sourceDirectionText": null,
        "fullDirectionText": "Remind Ada to move slowly and protect the alignment.",
        "spokenDirectionText": "Control the speed",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c212",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-7",
        "sourceDialogueText": "Let it go.",
        "sourceDirectionText": null,
        "fullDirectionText": "Keep your hand back and let the cart cross on the bridge’s own support. Give permission rather than reaching for or releasing the cart.",
        "spokenDirectionText": "Allow the crossing",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c214",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-7",
        "sourceDialogueText": "It crossed.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let surprise and relief show when the cart finally crosses.",
        "spokenDirectionText": "Celebrate quietly",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "paper-expanded-c216",
        "characterId": "ada",
        "sceneId": "paper-expanded-scene-7",
        "sourceDialogueText": "What do you see?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask Ben what he sees, ready to listen rather than claim the win.",
        "spokenDirectionText": "Ask for reflection",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      }
    ]
  },
  "cafe-last-chair": {
    "storyId": "cafe-last-chair",
    "approvalStatus": "OWNER_ADOPTED_AFTER_INDEPENDENT_REVIEW",
    "beforeCatalogRevision": 3,
    "expectedCount": 222,
    "sourceDraftSha256": "0a0bcedd0298dec02e5c23b34d35c0bb65097e5fb3a5b7241229059db2241fda",
    "sourceInputSha256": "77f003e9af195bb75c8f7deb4851f292add8bf54782069378f7c34d50b0860d3",
    "ownerFidelityChoices": {},
    "rows": [
      {
        "cueId": "chair-expanded-c005",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "Morning.",
        "sourceDirectionText": null,
        "fullDirectionText": "Keep your greeting casual and brief. You have stopped beside Mara, but your attention is still on the outlet. Do not explain your interest yet.",
        "spokenDirectionText": "Casual, slightly distracted",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c007",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "I sat here yesterday.",
        "sourceDirectionText": null,
        "fullDirectionText": "Hold your ground beside the chair. Answer Dev as though sitting here yesterday should settle the question of whose chair it is. Make the claim sincerely, even if the reasoning is weak.",
        "spokenDirectionText": "Defend your claim",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c008",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "Historic claim. Very strong.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let a small pause follow Mara's claim. Give her a dry, measured response as though you are judging an important argument. Keep the sarcasm quiet rather than playing for a laugh.",
        "spokenDirectionText": "Quiet, dry sarcasm",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c010",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "I came prepared.",
        "sourceDirectionText": null,
        "fullDirectionText": "Show off your homemade reservation sign with genuine pride. Speak as though bringing it proves you have thought of everything. Do not apologize for how homemade it looks.",
        "spokenDirectionText": "Proudly show off",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c013",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "You printed this at home.",
        "sourceDirectionText": null,
        "fullDirectionText": "Study the sign for another moment, then look at Mara. State your observation plainly, letting your disbelief show through a small pause. Give Mara room to answer without turning this into an argument.",
        "spokenDirectionText": "Dry disbelief",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c014",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "I laminated it.",
        "sourceDirectionText": null,
        "fullDirectionText": "Show how proud you are of laminating the sign, as though that settles Dev's doubts completely.",
        "spokenDirectionText": "Pleased with yourself",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c016",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "Mock the system all you want. The system is waterproof.",
        "sourceDirectionText": null,
        "fullDirectionText": "Treat the waterproof sign as a serious achievement; let Dev's mockery make you more determined.",
        "spokenDirectionText": "Defend the system",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c021",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "No problem.",
        "sourceDirectionText": null,
        "fullDirectionText": "Answer quickly and lightly, hiding the flash of alarm at the low battery number. Keep your face calm so Mara cannot see how urgently you need the outlet. This is concealment, not agreement.",
        "spokenDirectionText": "Hide your alarm",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c024",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "Twelve seconds? That is a bold slide deck.",
        "sourceDirectionText": null,
        "fullDirectionText": "Turn the tiny presentation time into a gently pointed joke, enjoying the absurd comparison.",
        "spokenDirectionText": "Mock the timing",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c026",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "Technically, the chair is beside the outlet.",
        "sourceDirectionText": null,
        "fullDirectionText": "Indicate the relationship between the chair and outlet as if precise wording will finally win you access.",
        "spokenDirectionText": "Reason your way in",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c027",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "There is no technically.",
        "sourceDirectionText": null,
        "fullDirectionText": "Cut off the technical explanation immediately; you will not allow the chair dispute to become wordplay.",
        "spokenDirectionText": "Reject the loophole",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c029",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "You are staring at the outlet like it owes you money.",
        "sourceDirectionText": null,
        "fullDirectionText": "Watch Dev focus on the outlet and challenge the intensity of that stare instead of the chair claim.",
        "spokenDirectionText": "Call out distraction",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c030",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "I respect infrastructure.",
        "sourceDirectionText": null,
        "fullDirectionText": "Keep your face completely serious while using an absurdly grand phrase to defend staring at the outlet.",
        "spokenDirectionText": "Deadpan excuse",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c032",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "Do I need a referee?",
        "sourceDirectionText": null,
        "fullDirectionText": "Look from one disputant to the other and ask the referee question with dry patience.",
        "spokenDirectionText": "Restore order",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c033",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "No. I have paperwork.",
        "sourceDirectionText": null,
        "fullDirectionText": "Present the paper sign as decisive evidence, not a craft project; expect Luz to take it seriously.",
        "spokenDirectionText": "Cite your evidence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c034",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-1",
        "sourceDialogueText": "She has craft supplies.",
        "sourceDirectionText": null,
        "fullDirectionText": "Counter Mara's claim by focusing on the homemade materials; do not make a big show of the joke.",
        "spokenDirectionText": "Undercut politely",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c036",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "All right. Nobody touches the chair for ten seconds.",
        "sourceDirectionText": null,
        "fullDirectionText": "Take charge of the chair with a specific ten-second pause; make sure both people stop reaching.",
        "spokenDirectionText": "Set a firm boundary",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c039",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "I can hear both of you from the register. That is bad for all three of us.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let them hear that the argument has reached your register; ask for quiet without losing your composure.",
        "spokenDirectionText": "Publicly embarrassed",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c040",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "I was here first.",
        "sourceDirectionText": null,
        "fullDirectionText": "Jump in promptly with the point that matters most to you, even though Luz is trying to reset things.",
        "spokenDirectionText": "Claim first arrival",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c041",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "By one elbow.",
        "sourceDirectionText": null,
        "fullDirectionText": "Correct the size of Mara's supposed lead with a small, sharp observation.",
        "spokenDirectionText": "Make it precise",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c042",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "I did not ask who won the sprint.",
        "sourceDirectionText": null,
        "fullDirectionText": "Reject the first-arrival argument and remind them that this is not a race.",
        "spokenDirectionText": "Refuse the contest",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c047",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "One sentence. Fine.",
        "sourceDirectionText": null,
        "fullDirectionText": "Agree to one sentence reluctantly, already deciding how to make it count.",
        "spokenDirectionText": "Accept the limit",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c054",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "That was seven words about a wall.",
        "sourceDirectionText": null,
        "fullDirectionText": "Deliver your exact word-count verdict as an unimpressed referee trying to get a real answer.",
        "spokenDirectionText": "Count the words",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c055",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "Very supportive wall.",
        "sourceDirectionText": null,
        "fullDirectionText": "Defend your wall comment with sincere-sounding enthusiasm that makes the joke drier.",
        "spokenDirectionText": "Praise the wall",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c056",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "Dev.",
        "sourceDirectionText": null,
        "fullDirectionText": "Say Dev's name as a complete warning; give him space to recognize he has gone off course.",
        "spokenDirectionText": "Final warning",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c057",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "I used one sentence.",
        "sourceDirectionText": null,
        "fullDirectionText": "Defend yourself with the narrowest possible reading of Luz's instruction.",
        "spokenDirectionText": "Technically compliant",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c058",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "And somehow less information.",
        "sourceDirectionText": null,
        "fullDirectionText": "Note how little Dev explained, letting the absence of useful information carry the joke.",
        "spokenDirectionText": "Point out emptiness",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c059",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "Do you need power for something important?",
        "sourceDirectionText": null,
        "fullDirectionText": "Redirect away from the chair to ask what power is actually needed for.",
        "spokenDirectionText": "Get to the need",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c061",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "Need is a strong word.",
        "sourceDirectionText": null,
        "fullDirectionText": "React to the word need as if debating vocabulary could protect your embarrassment.",
        "spokenDirectionText": "Avoid admitting urgency",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c062",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "Your screen is flashing red.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point to the red screen and give Dev no room to pretend his power problem is minor.",
        "spokenDirectionText": "Expose the battery",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c063",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-2",
        "sourceDialogueText": "It enjoys drama.",
        "sourceDirectionText": null,
        "fullDirectionText": "Treat the flashing warning as the screen's personality, trying to avoid a straight answer.",
        "spokenDirectionText": "Make a weak joke",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c066",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Totally fine.",
        "sourceDirectionText": null,
        "fullDirectionText": "Say it too quickly and lightly, trying to convince everyone your situation is fine.",
        "spokenDirectionText": "Forced reassurance",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c072",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Careful.",
        "sourceDirectionText": null,
        "fullDirectionText": "Warn Dev promptly when his physical solution begins to look risky; protect the space.",
        "spokenDirectionText": "Stop the movement",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c073",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "I am measuring.",
        "sourceDirectionText": null,
        "fullDirectionText": "Defend your awkward maneuver as careful measurement rather than desperation.",
        "spokenDirectionText": "Act methodical",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c074",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "With your whole arm?",
        "sourceDirectionText": null,
        "fullDirectionText": "Look at Dev's outstretched arm, then question his unusual measuring technique.",
        "spokenDirectionText": "Challenge the method",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c076",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "There is a geometry solution here.",
        "sourceDirectionText": null,
        "fullDirectionText": "Study the space intently and present geometry as though it can solve the outlet problem.",
        "spokenDirectionText": "Sell the theory",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c077",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Is the solution asking me to move?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask the question directly while guarding your place, alert to any hidden plan to move you.",
        "spokenDirectionText": "Test his intent",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c078",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "No. That would be too easy.",
        "sourceDirectionText": null,
        "fullDirectionText": "Concede that asking her to move would be simpler while refusing to make that request.",
        "spokenDirectionText": "Admit the complication",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c079",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Good. I was worried we might solve this before breakfast.",
        "sourceDirectionText": null,
        "fullDirectionText": "Watch both adults work around the obvious answer; make the joke sound like weary relief.",
        "spokenDirectionText": "Dryly supervise",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c083",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "How soon?",
        "sourceDirectionText": null,
        "fullDirectionText": "Set aside the chair contest and ask about the presentation with real interest.",
        "spokenDirectionText": "Demand a timeline",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c084",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "What?",
        "sourceDirectionText": null,
        "fullDirectionText": "Look up from your plan, surprised that Mara is asking about your work.",
        "spokenDirectionText": "Caught off guard",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c085",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "The presentation.",
        "sourceDirectionText": null,
        "fullDirectionText": "Clarify that you mean the presentation itself, not the chair dispute.",
        "spokenDirectionText": "Name the concern",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c086",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Soon is relative.",
        "sourceDirectionText": null,
        "fullDirectionText": "Make a vague argument about time rather than reveal the actual deadline.",
        "spokenDirectionText": "Evade the clock",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c087",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "How soon?",
        "sourceDirectionText": null,
        "fullDirectionText": "Repeat your question without softening it, letting Dev see he still has not answered.",
        "spokenDirectionText": "Ask again plainly",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c088",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Not helpful.",
        "sourceDirectionText": null,
        "fullDirectionText": "Deflect her question with a dry remark because admitting urgency feels uncomfortable.",
        "spokenDirectionText": "Protect your pride",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c089",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "That was not a number.",
        "sourceDirectionText": null,
        "fullDirectionText": "Wait for a real time estimate; don't accept his wordplay as an answer.",
        "spokenDirectionText": "Call out the dodge",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c090",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Correct.",
        "sourceDirectionText": null,
        "fullDirectionText": "Acknowledge the criticism with an unhelpful little victory, keeping the real number hidden.",
        "spokenDirectionText": "Own the evasion",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c096",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "You are beautifully not plugged in.",
        "sourceDirectionText": null,
        "fullDirectionText": "Notice the charger is still hanging uselessly, not connected to an outlet. Point out with gentle, teasing precision that Dev has not plugged in his laptop, even though its battery is still running dangerously low. Do not suggest the laptop is already dead.",
        "spokenDirectionText": "Needle the failure",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c097",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Temporary detail.",
        "sourceDirectionText": null,
        "fullDirectionText": "Dismiss the lack of charging as temporary while privately keeping watch on the screen.",
        "spokenDirectionText": "Minimize the issue",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c100",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Are you building furniture now?",
        "sourceDirectionText": null,
        "fullDirectionText": "Look at the objects Dev is moving and ask whether he has started making furniture.",
        "spokenDirectionText": "Challenge the scheme",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c101",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "I am adapting.",
        "sourceDirectionText": null,
        "fullDirectionText": "Protect your improvised plan by naming it as flexibility; avoid admitting it is ridiculous.",
        "spokenDirectionText": "Call it adapting",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c102",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "You are creating a safety meeting.",
        "sourceDirectionText": null,
        "fullDirectionText": "Make your safety objection practical and immediate; you do not want a café hazard.",
        "spokenDirectionText": "Stop unsafe improvising",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c104",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Fine.",
        "sourceDirectionText": null,
        "fullDirectionText": "Give up this attempt with a short concession and an exhale.",
        "spokenDirectionText": "Reluctant surrender",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c107",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Hypothetically, do you value breakfast?",
        "sourceDirectionText": null,
        "fullDirectionText": "Test whether breakfast might persuade Mara, pretending the offer is only hypothetical.",
        "spokenDirectionText": "Float an offer",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c108",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-3",
        "sourceDialogueText": "Depends how illegal the next sentence is.",
        "sourceDirectionText": null,
        "fullDirectionText": "Take the bait cautiously and signal that you hear a questionable proposal coming.",
        "spokenDirectionText": "Suspect the angle",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c113",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "It is not bribery. It is breakfast with terms.",
        "sourceDirectionText": null,
        "fullDirectionText": "Insist on a harmless label for the food offer, trying to sound reasonable.",
        "spokenDirectionText": "Rename the bribe",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c114",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "That is bribery before nine.",
        "sourceDirectionText": null,
        "fullDirectionText": "Name the offer for what it is without anger; enjoy beating Dev to the obvious conclusion.",
        "spokenDirectionText": "Call it bribery",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c115",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Fine. A breakfast partnership.",
        "sourceDirectionText": null,
        "fullDirectionText": "Switch terms quickly, refusing to admit the breakfast offer was a bribe.",
        "spokenDirectionText": "Rebrand again",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c117",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "I already have a chair partnership. It is called sitting.",
        "sourceDirectionText": null,
        "fullDirectionText": "Explain why your seat is already fully occupied, leaning into the absurd word partnership.",
        "spokenDirectionText": "Protect the chair",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c118",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "No bidding war.",
        "sourceDirectionText": null,
        "fullDirectionText": "Interrupt before food offers turn the seating fight into a formal bidding contest.",
        "spokenDirectionText": "Stop the auction",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c119",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "I was not bidding.",
        "sourceDirectionText": null,
        "fullDirectionText": "Protest the accusation with a straight face although the food offer is obvious.",
        "spokenDirectionText": "Defend the offer",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c120",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "You added food.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point out that food was added to the negotiations; keep your ruling simple.",
        "spokenDirectionText": "State the evidence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c121",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "People add food to things all the time.",
        "sourceDirectionText": null,
        "fullDirectionText": "Argue that sharing food is common, as though context doesn't matter.",
        "spokenDirectionText": "Normalize the tactic",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c122",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Not usually to furniture disputes.",
        "sourceDirectionText": null,
        "fullDirectionText": "Note the unusual setting for a food bargain while maintaining your claim to the chair.",
        "spokenDirectionText": "Expose the absurdity",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c124",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Ten minutes.",
        "sourceDirectionText": null,
        "fullDirectionText": "Offer ten minutes plainly, watching for a possible change in Mara's answer.",
        "spokenDirectionText": "Make a small bid",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c125",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "No.",
        "sourceDirectionText": null,
        "fullDirectionText": "Say no without hesitation or explanation; make the boundary unmistakable.",
        "spokenDirectionText": "Hold your boundary",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c126",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Eight.",
        "sourceDirectionText": null,
        "fullDirectionText": "Try a smaller number immediately, hoping the shorter time sounds reasonable.",
        "spokenDirectionText": "Reduce the request",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c127",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "That is not how no works.",
        "sourceDirectionText": null,
        "fullDirectionText": "Show Dev that refusing once was not an invitation to negotiate.",
        "spokenDirectionText": "Reject the bargaining",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c128",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Six, and I stop talking.",
        "sourceDirectionText": null,
        "fullDirectionText": "Make one final offer, adding your own silence as a selling point.",
        "spokenDirectionText": "Offer silence too",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c129",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Now you have added value.",
        "sourceDirectionText": null,
        "fullDirectionText": "Acknowledge that silence would be useful, but don't surrender your position outright.",
        "spokenDirectionText": "Enjoy the concession",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c133",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "How much battery do you actually have?",
        "sourceDirectionText": null,
        "fullDirectionText": "Shift from bargaining to the concrete battery percentage and wait for a number.",
        "spokenDirectionText": "Ask for facts",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c134",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Enough.",
        "sourceDirectionText": null,
        "fullDirectionText": "Give a confident answer that avoids sharing how little charge is left.",
        "spokenDirectionText": "Hide the number",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c135",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "That is not a percentage.",
        "sourceDirectionText": null,
        "fullDirectionText": "Demand an actual percentage rather than Dev's unsupported claim.",
        "spokenDirectionText": "Reject vague reassurance",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c136",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "It is an emotional percentage.",
        "sourceDirectionText": null,
        "fullDirectionText": "Call your anxiety a percentage, using humor to hide the battery emergency.",
        "spokenDirectionText": "Invent a category",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c137",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Those are not accepted by the charger.",
        "sourceDirectionText": null,
        "fullDirectionText": "Keep your café-owner logic literal: a charger does not care about feelings.",
        "spokenDirectionText": "Rule out nonsense",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c141",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Was that your presentation reminder?",
        "sourceDirectionText": null,
        "fullDirectionText": "Catch the reminder on his screen and ask about it before he hides the urgency.",
        "spokenDirectionText": "Identify the alarm",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c142",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Could have been anything.",
        "sourceDirectionText": null,
        "fullDirectionText": "Act unconcerned and suggest the alert might be unrelated to his presentation.",
        "spokenDirectionText": "Deflect the notification",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c143",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "It said presentation.",
        "sourceDirectionText": null,
        "fullDirectionText": "Refer to the visible word on the reminder; don't let Dev escape what you saw.",
        "spokenDirectionText": "Read the evidence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c144",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Very nosy screen.",
        "sourceDirectionText": null,
        "fullDirectionText": "Treat the screen as nosy to conceal your embarrassment at being found out.",
        "spokenDirectionText": "Blame the device",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c146",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-4",
        "sourceDialogueText": "Stop. New hearing.",
        "sourceDirectionText": null,
        "fullDirectionText": "Stop both sides with practiced authority; reset the discussion toward the real issue.",
        "spokenDirectionText": "Call another hearing",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c149",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Why would I help his case?",
        "sourceDirectionText": null,
        "fullDirectionText": "Let your resistance show; you are not ready to become Dev's advocate.",
        "spokenDirectionText": "Question helping him",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c150",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Because you have spent ten minutes proving you know his case.",
        "sourceDirectionText": null,
        "fullDirectionText": "Show Mara that she has been observing Dev closely enough to explain his need.",
        "spokenDirectionText": "Point out her insight",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c151",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "And I object to the word case.",
        "sourceDirectionText": null,
        "fullDirectionText": "Interrupt the formal hearing label without hiding that the conversation has become personal.",
        "spokenDirectionText": "Object playfully",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c152",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Of course you do.",
        "sourceDirectionText": null,
        "fullDirectionText": "Respond as if Dev's objection was entirely predictable, then move the hearing along.",
        "spokenDirectionText": "Expected protest",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c156",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "That last part was not required.",
        "sourceDirectionText": null,
        "fullDirectionText": "React to Mara's last observation with a little wounded pride.",
        "spokenDirectionText": "Resist the sting",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c157",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "It was accurate.",
        "sourceDirectionText": null,
        "fullDirectionText": "Do not take back your observation simply because Dev dislikes hearing it.",
        "spokenDirectionText": "Stand by the truth",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c158",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Keep going.",
        "sourceDirectionText": null,
        "fullDirectionText": "Prompt Mara to finish explaining, keeping the focus on what Dev needs.",
        "spokenDirectionText": "Encourage the answer",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c160",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "He needs power more than he needs the chair.",
        "sourceDirectionText": null,
        "fullDirectionText": "Say plainly that power matters more than the chair; let your certainty replace the fight.",
        "spokenDirectionText": "Name his real need",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c162",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Dev. Your turn.",
        "sourceDirectionText": null,
        "fullDirectionText": "Turn to Dev after Mara has argued for him. Firmly hand him his turn under the same rule: he must make the case for why Mara deserves the chair. Wait for him to look at her needs rather than defend his own.",
        "spokenDirectionText": "Prompt Dev to speak",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c167",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "She moves tables when the blender starts. She leaves when the lunch crowd comes.",
        "sourceDirectionText": null,
        "fullDirectionText": "Describe Mara's repeated table movements as things you have genuinely noticed, not ammunition.",
        "spokenDirectionText": "Reveal her habits",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c168",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "You notice the blender thing?",
        "sourceDirectionText": null,
        "fullDirectionText": "Drop the defensive banter for a moment; ask because Dev remembered a small detail.",
        "spokenDirectionText": "Surprised to be seen",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c169",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "It is not subtle.",
        "sourceDirectionText": null,
        "fullDirectionText": "Pretend his observation was obvious, gently covering his own attention to Mara.",
        "spokenDirectionText": "Play it down",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c171",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Yes.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let a simple yes stand without decoration or a joke.",
        "spokenDirectionText": "Give a true answer",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c174",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Check it.",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask Dev to look at the screen now, choosing facts over further bargaining.",
        "spokenDirectionText": "Prompt the check",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c175",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "I would rather not.",
        "sourceDirectionText": null,
        "fullDirectionText": "Keep your hand from the screen at first; you know the battery answer is uncomfortable.",
        "spokenDirectionText": "Delay the truth",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c176",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Dev.",
        "sourceDirectionText": null,
        "fullDirectionText": "Say his name firmly enough to end the avoidance, without humiliating him.",
        "spokenDirectionText": "Insist gently",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c180",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Okay.",
        "sourceDirectionText": null,
        "fullDirectionText": "Take the moment to check and accept that the answer cannot stay hidden.",
        "spokenDirectionText": "Face the number",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c181",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "How bad?",
        "sourceDirectionText": null,
        "fullDirectionText": "Look at his reaction and ask for the actual number, not a brave face.",
        "spokenDirectionText": "Ask with concern",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c182",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "One.",
        "sourceDirectionText": null,
        "fullDirectionText": "Give the tiny number quietly, dropping the performance of confidence.",
        "spokenDirectionText": "Admit the one percent",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c186",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Move.",
        "sourceDirectionText": null,
        "fullDirectionText": "Act immediately and give Dev access to the chair now that you understand the urgency.",
        "spokenDirectionText": "Make the choice",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c187",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "What?",
        "sourceDirectionText": null,
        "fullDirectionText": "Stop moving and ask what Mara means; you didn't expect her to yield.",
        "spokenDirectionText": "Caught by surprise",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c189",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Mara, you do not have to.",
        "sourceDirectionText": null,
        "fullDirectionText": "Tell Mara she need not give up the chair, meaning it despite your urgency.",
        "spokenDirectionText": "Release the obligation",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c192",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Are you sure?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask again because you do not want a favor made under pressure.",
        "spokenDirectionText": "Check her consent",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c193",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "No, I am giving away my favorite chair as a prank.",
        "sourceDirectionText": null,
        "fullDirectionText": "Make it clear you are serious by treating the idea of a prank as ridiculous.",
        "spokenDirectionText": "Use playful sarcasm",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c194",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Right.",
        "sourceDirectionText": null,
        "fullDirectionText": "Stop questioning the offer; respond briefly before you take the seat.",
        "spokenDirectionText": "Accept her answer",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c195",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Sit before your computer becomes a decorative rectangle.",
        "sourceDirectionText": null,
        "fullDirectionText": "Push Dev to sit and charge before his computer becomes useless.",
        "spokenDirectionText": "Hurry him kindly",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c198",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "I should have said this ten minutes ago.",
        "sourceDirectionText": null,
        "fullDirectionText": "Start admitting you should have asked for help earlier, not just argued about furniture.",
        "spokenDirectionText": "Begin to own it",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c201",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "I was not asking for a confession.",
        "sourceDirectionText": null,
        "fullDirectionText": "Interrupt his confession gently; helping did not require a speech of guilt.",
        "spokenDirectionText": "Reject self-punishment",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c202",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "I may have overshot.",
        "sourceDirectionText": null,
        "fullDirectionText": "After Mara says she was not asking for a confession, register that your admission went much further than she needed. Acknowledge that excess with a small, self-aware smile, without reopening the original chair dispute.",
        "spokenDirectionText": "Admit overdoing it",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c203",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "A little.",
        "sourceDirectionText": null,
        "fullDirectionText": "Confirm the understatement with a small smile rather than another lecture.",
        "spokenDirectionText": "Keep it light",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c204",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "Still better than wall energy.",
        "sourceDirectionText": null,
        "fullDirectionText": "Use the earlier wall-energy remark to ease the room's tension.",
        "spokenDirectionText": "Recall the old joke",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c205",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-5",
        "sourceDialogueText": "That was a difficult chapter in my life.",
        "sourceDirectionText": null,
        "fullDirectionText": "Treat your earlier explanation like a dramatic past chapter, laughing at yourself.",
        "spokenDirectionText": "Take the teasing",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c214",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-6",
        "sourceDialogueText": "Is it charging?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask with cautious hope whether the laptop is actually receiving power.",
        "spokenDirectionText": "Check the charge",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c215",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-6",
        "sourceDialogueText": "It is thinking about it.",
        "sourceDirectionText": null,
        "fullDirectionText": "Watch the charging indicator and answer without pretending certainty.",
        "spokenDirectionText": "Wait for the response",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c216",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-6",
        "sourceDialogueText": "Electricity usually decides faster.",
        "sourceDirectionText": null,
        "fullDirectionText": "Compare this to how quickly electricity normally works, teasing without cruelty.",
        "spokenDirectionText": "Question the delay",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c218",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-6",
        "sourceDialogueText": "Maybe the plug is loose.",
        "sourceDirectionText": null,
        "fullDirectionText": "Consider the plug itself; look toward the connection rather than blame the chair.",
        "spokenDirectionText": "Try a simple cause",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c220",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-6",
        "sourceDialogueText": "No.",
        "sourceDirectionText": null,
        "fullDirectionText": "Give the answer plainly when the connection does not work.",
        "spokenDirectionText": "Recognize the problem",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c223",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-6",
        "sourceDialogueText": "Since yesterday?",
        "sourceDirectionText": null,
        "fullDirectionText": "React to the possibility that the outlet has been broken since yesterday.",
        "spokenDirectionText": "Hear the bad news",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c224",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-6",
        "sourceDialogueText": "Since yesterday.",
        "sourceDirectionText": null,
        "fullDirectionText": "Repeat the timeframe directly; make clear the outlet was never working.",
        "spokenDirectionText": "Confirm without drama",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c226",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-6",
        "sourceDialogueText": "So we held a hearing over a broken wall.",
        "sourceDirectionText": null,
        "fullDirectionText": "Realize all the arguing centered on a useless outlet, letting disbelief turn to humor.",
        "spokenDirectionText": "See the irony",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c234",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "Dev.",
        "sourceDirectionText": null,
        "fullDirectionText": "Say Dev's name to stop the joking and bring him back to what matters.",
        "spokenDirectionText": "Ask for attention",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c235",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "I know.",
        "sourceDirectionText": null,
        "fullDirectionText": "Assume Mara means the dead laptop; answer with weary recognition.",
        "spokenDirectionText": "Know the obvious",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c236",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "No. You know the laptop died. I do not think you know the other part yet.",
        "sourceDirectionText": null,
        "fullDirectionText": "Tell him plainly that the laptop is only one part of what he missed.",
        "spokenDirectionText": "Shift his thinking",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c238",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "What other part?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask seriously what else Mara means, giving her space to explain.",
        "spokenDirectionText": "Invite the point",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c239",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "You spent half an hour asking a chair for help.",
        "sourceDirectionText": null,
        "fullDirectionText": "Show him how he demanded help from a chair instead of asking a person.",
        "spokenDirectionText": "Name the pattern",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c240",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "The chair was not very responsive.",
        "sourceDirectionText": null,
        "fullDirectionText": "Deflect once with a joke about the unresponsive chair, without denying her point.",
        "spokenDirectionText": "Accept the joke",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c255",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "That is painfully fair.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let the fairness of the criticism sting, then admit it rather than argue.",
        "spokenDirectionText": "Receive the truth",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c259",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "Luz, where can I run this without turning your café into a trip hazard?",
        "sourceDirectionText": null,
        "fullDirectionText": "Turn to Luz and request a safe cord route rather than moving things unasked.",
        "spokenDirectionText": "Ask permission first",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c261",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "Behind the table leg, along the wall, then under the counter lip.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point out the exact route behind the table leg, along the wall and under the counter.",
        "spokenDirectionText": "Give practical directions",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c262",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "Can I move this table two inches?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask before shifting the table, keeping the movement small and clear.",
        "spokenDirectionText": "Request the adjustment",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c264",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "You are on a streak.",
        "sourceDirectionText": null,
        "fullDirectionText": "Tease Dev because he is finally asking instead of claiming space.",
        "spokenDirectionText": "Notice his improvement",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c265",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "Two inches. Not a remodel.",
        "sourceDirectionText": null,
        "fullDirectionText": "Allow the two-inch move but guard against another large furniture project.",
        "spokenDirectionText": "Set the exact limit",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c270",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "Light.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let the charging light register before you say the single hopeful word.",
        "spokenDirectionText": "Watch for power",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c271",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "Very observant.",
        "sourceDirectionText": null,
        "fullDirectionText": "Acknowledge that Dev has finally noticed light, with affectionate dryness.",
        "spokenDirectionText": "Tease his observation",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c272",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "I have had a difficult relationship with electricity this morning.",
        "sourceDirectionText": null,
        "fullDirectionText": "Treat the electricity struggle as a humorous personal feud you can now laugh about.",
        "spokenDirectionText": "Admit a hard morning",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c273",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-7",
        "sourceDialogueText": "Mostly with sentences.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point out his trouble was mostly with communicating, not electricity.",
        "spokenDirectionText": "Correct the true problem",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c277",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Do not attack it.",
        "sourceDirectionText": null,
        "fullDirectionText": "Watch Dev's hand near the device and warn him not to rush the boot.",
        "spokenDirectionText": "Prevent another mistake",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c278",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "I am waiting.",
        "sourceDirectionText": null,
        "fullDirectionText": "Keep the eager hand still and insist you are waiting, even if it is difficult.",
        "spokenDirectionText": "Show deliberate patience",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c279",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Your finger is hovering.",
        "sourceDirectionText": null,
        "fullDirectionText": "Call attention to his finger so he cannot pretend he is being patient.",
        "spokenDirectionText": "Catch the hovering finger",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c281",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "My finger is optimistic.",
        "sourceDirectionText": null,
        "fullDirectionText": "Describe your eagerness as optimism, keeping the mood playful.",
        "spokenDirectionText": "Defend the finger",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c284",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "How long until your presentation?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask for the real presentation deadline now that the crisis is in view.",
        "spokenDirectionText": "Ask the hard time",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c286",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Eleven minutes.",
        "sourceDirectionText": null,
        "fullDirectionText": "Answer with the exact eleven-minute limit; drop evasive language.",
        "spokenDirectionText": "Give the deadline",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c287",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "That is not much.",
        "sourceDirectionText": null,
        "fullDirectionText": "Hear how little time remains and say so with concern.",
        "spokenDirectionText": "Acknowledge urgency",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c288",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "No.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let the short answer show you understand the risk and have no joke ready.",
        "spokenDirectionText": "Agree without hiding",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c290",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Do you want me to check your opening while it boots?",
        "sourceDirectionText": null,
        "fullDirectionText": "Suggest checking his opening while the computer boots, giving him a useful option.",
        "spokenDirectionText": "Offer specific help",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c292",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Yes. Please.",
        "sourceDirectionText": null,
        "fullDirectionText": "Say yes and please directly, taking Mara's help without bargaining.",
        "spokenDirectionText": "Accept graciously",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c293",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Look at that. Full sentence. No treaty.",
        "sourceDirectionText": null,
        "fullDirectionText": "Notice his polite full sentence and tease him gently for finally asking.",
        "spokenDirectionText": "Celebrate progress",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c294",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Do not make me regret personal growth.",
        "sourceDirectionText": null,
        "fullDirectionText": "Warn against too much teasing while allowing yourself to smile.",
        "spokenDirectionText": "Protect your dignity",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c295",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "It is too late. We all witnessed it.",
        "sourceDirectionText": null,
        "fullDirectionText": "Tell both of them you noticed Dev's better behavior, enjoying the moment.",
        "spokenDirectionText": "Witness the change",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c297",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "First line: 'Today I want to show you why the simplest solution is sometimes the strongest.'",
        "sourceDirectionText": null,
        "fullDirectionText": "Read the opening like a presentation, trying to sound professional despite the morning.",
        "spokenDirectionText": "Rehearse earnestly",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c299",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "No.",
        "sourceDirectionText": null,
        "fullDirectionText": "Reject the opening immediately because its simplicity claim clashes with today's mess.",
        "spokenDirectionText": "Give honest feedback",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c300",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "I know.",
        "sourceDirectionText": null,
        "fullDirectionText": "Acknowledge the problem before Mara has to explain the irony.",
        "spokenDirectionText": "Already aware",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c301",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "You cannot say that today with a straight face.",
        "sourceDirectionText": null,
        "fullDirectionText": "Remind Dev that a speech about simple solutions cannot ignore his chair battle.",
        "spokenDirectionText": "Point out irony",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c302",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "I may have accidentally become my own visual aid.",
        "sourceDirectionText": null,
        "fullDirectionText": "Realize you became a perfect example of the mistake you're discussing.",
        "spokenDirectionText": "Laugh at yourself",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c303",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Use the chair dispute as slide one.",
        "sourceDirectionText": null,
        "fullDirectionText": "Offer the chair fight as a first slide with mischievous practical confidence.",
        "spokenDirectionText": "Suggest using the story",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c304",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "My professional reputation would not survive the laminated sign.",
        "sourceDirectionText": null,
        "fullDirectionText": "Imagine the laminated sign in a professional presentation and protest playfully.",
        "spokenDirectionText": "Protect your reputation",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c306",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "This is peer-reviewed furniture law.",
        "sourceDirectionText": null,
        "fullDirectionText": "Present the homemade sign as if experts have formally approved it.",
        "spokenDirectionText": "Defend the evidence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c307",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "By whom?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask who supposedly reviewed the sign, knowing the answer will be absurd.",
        "spokenDirectionText": "Request the experts",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c308",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "My kitchen printer.",
        "sourceDirectionText": null,
        "fullDirectionText": "Name the kitchen printer as your expert with absolute confidence.",
        "spokenDirectionText": "Claim printer authority",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c312",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Everything is here.",
        "sourceDirectionText": null,
        "fullDirectionText": "Check the restored files on your screen before saying everything is present.",
        "spokenDirectionText": "Confirm recovery",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c313",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Battery?",
        "sourceDirectionText": null,
        "fullDirectionText": "Seek the battery number to make sure Dev can actually present.",
        "spokenDirectionText": "Ask about remaining power",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c315",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Three percent and climbing.",
        "sourceDirectionText": null,
        "fullDirectionText": "Give the three-percent figure with relief and note it is rising.",
        "spokenDirectionText": "Report the gain",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c316",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Try not to spend all three at once.",
        "sourceDirectionText": null,
        "fullDirectionText": "Warn him not to waste the tiny gain with another needless argument.",
        "spokenDirectionText": "Offer a caution",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c317",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "I have learned respect for small numbers.",
        "sourceDirectionText": null,
        "fullDirectionText": "Take the warning seriously and joke about what small percentages mean now.",
        "spokenDirectionText": "Respect the number",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c319",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Run the opening once. Quietly.",
        "sourceDirectionText": null,
        "fullDirectionText": "Offer a single low-volume rehearsal, keeping the café workable for others.",
        "spokenDirectionText": "Invite a quiet run",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c321",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Would that ruin your writing time?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask whether listening would interrupt Mara's writing before accepting more help.",
        "spokenDirectionText": "Consider her time",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c323",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "One minute will not.",
        "sourceDirectionText": null,
        "fullDirectionText": "Give him a bounded minute of attention because you want to help without losing your morning.",
        "spokenDirectionText": "Offer one minute",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c324",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Then one minute. After that I shut up.",
        "sourceDirectionText": null,
        "fullDirectionText": "Agree to one minute and mean to stop at the limit this time.",
        "spokenDirectionText": "Promise restraint",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c325",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "I would like that promise in writing.",
        "sourceDirectionText": null,
        "fullDirectionText": "Treat his promise of silence as a contract worth documenting.",
        "spokenDirectionText": "Request written proof",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c326",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "I have a laminator.",
        "sourceDirectionText": null,
        "fullDirectionText": "Offer the obvious tool for making that promise permanent, proud of the callback.",
        "spokenDirectionText": "Reveal the laminator",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c327",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Of course you do.",
        "sourceDirectionText": null,
        "fullDirectionText": "Recognize that Mara still has a laminator, allowing the running joke to land.",
        "spokenDirectionText": "Accept the pattern",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c330",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "That part works. The second sentence is doing too much.",
        "sourceDirectionText": null,
        "fullDirectionText": "Approve the first part of Dev's opening, then identify the overloaded second sentence.",
        "spokenDirectionText": "Give precise feedback",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c332",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "You are right.",
        "sourceDirectionText": null,
        "fullDirectionText": "Drop the defensiveness and accept her note without debate.",
        "spokenDirectionText": "Admit she is right",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c333",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "I need a recording of that.",
        "sourceDirectionText": null,
        "fullDirectionText": "React to Dev agreeing as if you witnessed a rare and precious event.",
        "spokenDirectionText": "Catch the admission",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c334",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "One miracle per morning.",
        "sourceDirectionText": null,
        "fullDirectionText": "Joke that he has already offered as much humility as the morning allows.",
        "spokenDirectionText": "Limit the miracle",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c336",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Time.",
        "sourceDirectionText": null,
        "fullDirectionText": "Interrupt the exchange when the available rehearsal minute runs out.",
        "spokenDirectionText": "Call the deadline",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c338",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Thank you.",
        "sourceDirectionText": null,
        "fullDirectionText": "Look at Mara and Luz and thank them plainly for the help, with no joke.",
        "spokenDirectionText": "Offer real thanks",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c340",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "You are welcome.",
        "sourceDirectionText": null,
        "fullDirectionText": "Accept Dev's thanks warmly and briefly, letting the moment be genuine.",
        "spokenDirectionText": "Receive the thanks",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c342",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Can I leave the cord here until I head out?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask Luz if the safe cord can stay a little longer before you leave.",
        "spokenDirectionText": "Request cord access",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c343",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Yes. Now I am getting suspicious. You keep asking things.",
        "sourceDirectionText": null,
        "fullDirectionText": "Agree, then tease the growing list of things Dev now asks permission for.",
        "spokenDirectionText": "Notice his courtesy",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c344",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Do not worry. I am sure I can relapse into furniture law by lunch.",
        "sourceDirectionText": null,
        "fullDirectionText": "Joke that furniture-law habits might return, while showing you know better.",
        "spokenDirectionText": "Admit old habits",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c345",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-8",
        "sourceDialogueText": "Denied. We are passing a new statute.",
        "sourceDirectionText": null,
        "fullDirectionText": "Reject the relapse by framing a friendlier chair law for the café.",
        "spokenDirectionText": "Propose new rules",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c347",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "This thing caused at least twelve minutes of my morning.",
        "sourceDirectionText": null,
        "fullDirectionText": "Regard the sign and recall how much of your morning the dispute consumed.",
        "spokenDirectionText": "Count the cost",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c348",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "It brought structure.",
        "sourceDirectionText": null,
        "fullDirectionText": "Argue that the sign brought order, still attached to your homemade system.",
        "spokenDirectionText": "Claim a benefit",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c349",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "It brought exhibits.",
        "sourceDirectionText": null,
        "fullDirectionText": "Contribute to the courtroom joke as though the documents mattered.",
        "spokenDirectionText": "Add the exhibits",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c350",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "It brought two adults within seconds of arguing over elbow jurisdiction.",
        "sourceDirectionText": null,
        "fullDirectionText": "Remind everyone that a chair caused absurd arguments over where elbows belonged.",
        "spokenDirectionText": "Describe the chaos",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c351",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "That point was unresolved.",
        "sourceDirectionText": null,
        "fullDirectionText": "Insist one absurd point remains unresolved, enjoying the last argument.",
        "spokenDirectionText": "Preserve the dispute",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c352",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "I had precedent.",
        "sourceDirectionText": null,
        "fullDirectionText": "Play along as if precedent supports your side, keeping the tone mock-serious.",
        "spokenDirectionText": "Cite your evidence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c353",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "You had an elbow.",
        "sourceDirectionText": null,
        "fullDirectionText": "Point out all Dev really had was an elbow; end the legal posturing.",
        "spokenDirectionText": "Reduce it to facts",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c356",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "If we are going to have café law, make one useful rule.",
        "sourceDirectionText": null,
        "fullDirectionText": "Move past the joking and challenge them to make a rule that would help anyone.",
        "spokenDirectionText": "Seek one useful rule",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c357",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "No fighting over outlets?",
        "sourceDirectionText": null,
        "fullDirectionText": "Suggest not fighting over outlets as a practical beginning.",
        "spokenDirectionText": "Offer an obvious rule",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c358",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Too narrow.",
        "sourceDirectionText": null,
        "fullDirectionText": "Dismiss the narrow suggestion; the rule should work beyond this argument.",
        "spokenDirectionText": "Demand broader thinking",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c359",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "No homemade government documents?",
        "sourceDirectionText": null,
        "fullDirectionText": "Propose ending homemade legal documents with exasperated affection.",
        "spokenDirectionText": "Ban the paperwork",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c361",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Rejected.",
        "sourceDirectionText": null,
        "fullDirectionText": "Guard your beloved sign and veto any rule against such documents.",
        "spokenDirectionText": "Reject that immediately",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c363",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "What about this: before you claim the chair, trade for the chair, bribe for the chair, or create a constitutional crisis over the chair, say what you actually need.",
        "sourceDirectionText": null,
        "fullDirectionText": "Begin listing the absurd ways they tried to acquire the chair, building toward asking first.",
        "spokenDirectionText": "Try a better principle",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c364",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "That is annoyingly good.",
        "sourceDirectionText": null,
        "fullDirectionText": "Recognize Dev has a good idea even though it irritates you to agree.",
        "spokenDirectionText": "Reluctantly approve",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c365",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Shorten it.",
        "sourceDirectionText": null,
        "fullDirectionText": "Cut through his long legal wording and demand the shortest possible rule.",
        "spokenDirectionText": "Ask for brevity",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c366",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Ask first.",
        "sourceDirectionText": null,
        "fullDirectionText": "Let the simple two-word principle land plainly, with no explanation.",
        "spokenDirectionText": "State the answer",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c367",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Too normal.",
        "sourceDirectionText": null,
        "fullDirectionText": "Complain that the useful answer sounds disappointingly ordinary.",
        "spokenDirectionText": "Resist its simplicity",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c368",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Add unnecessary authority.",
        "sourceDirectionText": null,
        "fullDirectionText": "Give permission to dress up the simple rule with silly authority.",
        "spokenDirectionText": "Demand official language",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c370",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "'The Chair Act. Article One: Ask first.'",
        "sourceDirectionText": null,
        "fullDirectionText": "Announce the mock legislation with pride, making asking first sound official.",
        "spokenDirectionText": "Present the chair act",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c371",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Article Two: Kitchen printers have no legislative power.",
        "sourceDirectionText": null,
        "fullDirectionText": "Declare that homemade printer documents cannot make laws, eyeing Mara's sign.",
        "spokenDirectionText": "Limit printer power",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c372",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Vetoed.",
        "sourceDirectionText": null,
        "fullDirectionText": "Reject the attack on your printer's power without hesitation.",
        "spokenDirectionText": "Exercise the veto",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c373",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Article Two: If you hide the real problem, you buy breakfast.",
        "sourceDirectionText": null,
        "fullDirectionText": "Propose breakfast as the penalty for hiding a real problem, aimed at Dev.",
        "spokenDirectionText": "Add a consequence",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c374",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "I feel targeted.",
        "sourceDirectionText": null,
        "fullDirectionText": "Recognize yourself as the target and object with a small wounded smile.",
        "spokenDirectionText": "Feel the accusation",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c375",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "You were the research sample.",
        "sourceDirectionText": null,
        "fullDirectionText": "Remind him he supplied the evidence for this rule, enjoying the joke.",
        "spokenDirectionText": "Name the experiment",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c378",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "That is probably an improvement.",
        "sourceDirectionText": null,
        "fullDirectionText": "Accept that the new approach is probably better, sounding reluctantly hopeful.",
        "spokenDirectionText": "Acknowledge improvement",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c379",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Probably?",
        "sourceDirectionText": null,
        "fullDirectionText": "Catch Dev's probably and ask for a stronger admission.",
        "spokenDirectionText": "Challenge the qualifier",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c380",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "I am still grieving my appeal.",
        "sourceDirectionText": null,
        "fullDirectionText": "Pretend to grieve the appeal process even while accepting the outcome.",
        "spokenDirectionText": "Mourn the lost appeal",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c381",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "There was no appeal.",
        "sourceDirectionText": null,
        "fullDirectionText": "State flatly that no appeal existed; do not indulge another courtroom speech.",
        "spokenDirectionText": "Deny an appeal",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c382",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Exactly. Deeply flawed system.",
        "sourceDirectionText": null,
        "fullDirectionText": "Use the missing appeal as one last mock-legal complaint.",
        "spokenDirectionText": "Protest the system",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c385",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Six percent.",
        "sourceDirectionText": null,
        "fullDirectionText": "Read the battery number with real satisfaction after the long ordeal.",
        "spokenDirectionText": "Announce six percent",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c386",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Look at you. Wealthy.",
        "sourceDirectionText": null,
        "fullDirectionText": "React as if six percent makes Dev rich, warmly mocking the tiny success.",
        "spokenDirectionText": "Celebrate the fortune",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c387",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "I may buy a second percent.",
        "sourceDirectionText": null,
        "fullDirectionText": "Pretend you could purchase another percent, now comfortable enough to laugh.",
        "spokenDirectionText": "Joke about buying more",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c388",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "With words?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask whether he plans to buy power with more empty words.",
        "spokenDirectionText": "Check his currency",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c389",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "No. I have learned.",
        "sourceDirectionText": null,
        "fullDirectionText": "Reject the old tactic with a brief answer that proves you learned something.",
        "spokenDirectionText": "Show what changed",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c393",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Then yes.",
        "sourceDirectionText": null,
        "fullDirectionText": "Agree to the next step with less resistance than you showed at the beginning.",
        "spokenDirectionText": "Accept the offer",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c394",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "No conditions?",
        "sourceDirectionText": null,
        "fullDirectionText": "Ask whether her yes has hidden conditions, still adjusting to direct answers.",
        "spokenDirectionText": "Check for a catch",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c395",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "You are making this very hard.",
        "sourceDirectionText": null,
        "fullDirectionText": "Tell Dev his suspicion is making a simple favor unnecessarily difficult.",
        "spokenDirectionText": "Lose patience playfully",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c396",
        "characterId": "dev",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Sorry.",
        "sourceDirectionText": null,
        "fullDirectionText": "Give a sincere short apology and stop making the exchange harder.",
        "spokenDirectionText": "Apologize directly",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c397",
        "characterId": "mara",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "Better.",
        "sourceDirectionText": null,
        "fullDirectionText": "Reward the straightforward apology with a simple approving response.",
        "spokenDirectionText": "Acknowledge progress",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      },
      {
        "cueId": "chair-expanded-c399",
        "characterId": "luz",
        "sceneId": "chair-expanded-scene-9",
        "sourceDialogueText": "We still need the official ending.",
        "sourceDirectionText": null,
        "fullDirectionText": "Look around the café and insist the homemade legal proceedings need an official ending.",
        "spokenDirectionText": "Request a final ruling",
        "beforeGuidanceFields": {
          "spokenDirectionPending": true,
          "directionCaptionOnly": false
        }
      }
    ]
  },
  "missing-raven-mystery": {
    "storyId": "missing-raven-mystery",
    "approvalStatus": "OWNER_ADOPTED_AFTER_INDEPENDENT_REVIEW",
    "beforeCatalogRevision": 3,
    "expectedCount": 407,
    "sourceDraftSha256": "992ec5883002698bbcd20b5806883fd771067c923bcd0fc9f3037808fc09431b",
    "sourceInputSha256": "090d13a57ba911ca812511b28ca8b5638d8f564af31473c241618dceb8f0681d",
    "ownerFidelityChoices": {
      "raven-expanded-c053": {
        "short": "Show with two fingers.",
        "full": "Riley shows the small distance with two fingers.",
        "reason": "Preserve the authored two-finger demonstration; introduce no new physical measurement."
      },
      "raven-expanded-c079": {
        "short": "Let magnet swing back.",
        "full": "Sam lifts the magnet away and lets it swing back toward the wood.",
        "reason": "Preserve allowing the magnet to swing back under attraction. The exact full caption retains the preliminary lift and wood target; do not command an actor-driven return."
      },
      "raven-expanded-c180": {
        "short": "Let your face change.",
        "full": "Riley's face changes.",
        "reason": "Literal playable restatement without inventing an emotional interpretation."
      },
      "raven-expanded-c300": {
        "short": "Already know the answer.",
        "full": "Sam already knows the answer.",
        "reason": "Preserve prior knowledge without a silence instruction; dialogue remains unchanged."
      }
    },
    "rows": [
      {
        "cueId": "raven-expanded-c001",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "The raven should be here.",
        "sourceDirectionText": "Riley checks the shelf.",
        "fullDirectionText": "Riley checks the shelf.",
        "spokenDirectionText": "Check the shelf.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c002",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Maybe we missed something.",
        "sourceDirectionText": "Sam looks around the prop room.",
        "fullDirectionText": "Sam looks around the prop room.",
        "spokenDirectionText": "Look around.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks around the prop room.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-c01",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "No. No, no, no. The raven trophy was right here when I locked this cabinet.",
        "sourceDirectionText": "Riley stares at the empty shelf and checks the key.",
        "fullDirectionText": "Riley stares at the empty shelf and checks the key.",
        "spokenDirectionText": "Check the key.",
        "beforeGuidanceFields": {
          "directionText": "Riley stares at the empty shelf and checks the key.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-c02",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Before we accuse the supernatural, did the trophy perhaps learn to hide under tables?",
        "sourceDirectionText": "Sam checks beneath the nearest table.",
        "fullDirectionText": "Sam checks beneath the nearest table.",
        "spokenDirectionText": "Look under the table.",
        "beforeGuidanceFields": {
          "directionText": "Sam checks beneath the nearest table.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c005",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Nothing under there.",
        "sourceDirectionText": "Riley checks the floor beside the cabinet.",
        "fullDirectionText": "Riley checks the floor beside the cabinet.",
        "spokenDirectionText": "Check floor beside cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the floor beside the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c006",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Good. I was not ready to explain a haunted trophy to the cast.",
        "sourceDirectionText": "Sam checks behind a folded backdrop.",
        "fullDirectionText": "Sam checks behind a folded backdrop.",
        "spokenDirectionText": "Check behind backdrop.",
        "beforeGuidanceFields": {
          "directionText": "Sam checks behind a folded backdrop.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-c03",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "The lock is fine, the glass is fine, and I have the key. That makes absolutely no sense.",
        "sourceDirectionText": "Riley tests the cabinet door and studies the glass.",
        "fullDirectionText": "Riley tests the cabinet door and studies the glass.",
        "spokenDirectionText": "Test the cabinet door.",
        "beforeGuidanceFields": {
          "directionText": "Riley tests the cabinet door and studies the glass.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c008",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Could there be another key?",
        "sourceDirectionText": "Sam looks from Riley's key to the lock.",
        "fullDirectionText": "Sam looks from Riley's key to the lock.",
        "spokenDirectionText": "Compare key and lock.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks from Riley's key to the lock.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c009",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "The director has one. Hers is with her across the building.",
        "sourceDirectionText": "Riley checks the key tag.",
        "fullDirectionText": "Riley checks the key tag.",
        "spokenDirectionText": "Check the key tag.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the key tag.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c010",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "And yes, I was the last actor in here. I also enjoy not taking school trophies.",
        "sourceDirectionText": "Sam answers before Riley can ask.",
        "fullDirectionText": "Sam answers before Riley can ask.",
        "spokenDirectionText": "Answer before being asked.",
        "beforeGuidanceFields": {
          "directionText": "Sam answers before Riley can ask.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c011",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "I did not say you took it.",
        "sourceDirectionText": "Riley looks at Sam, then back at the cabinet.",
        "fullDirectionText": "Riley looks at Sam, then back at the cabinet.",
        "spokenDirectionText": "Look at Sam.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks at Sam, then back at the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c012",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Your eyebrows did.",
        "sourceDirectionText": "Sam points lightly at Riley's face, then drops the joke.",
        "fullDirectionText": "Sam points lightly at Riley's face, then drops the joke.",
        "spokenDirectionText": "Point at Riley’s face.",
        "beforeGuidanceFields": {
          "directionText": "Sam points lightly at Riley's face, then drops the joke.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c013",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Fine. I am trying to understand how a locked cabinet became empty.",
        "sourceDirectionText": "Riley closes the door once and checks the latch.",
        "fullDirectionText": "Riley closes the door once and checks the latch.",
        "spokenDirectionText": "Close the door once.",
        "beforeGuidanceFields": {
          "directionText": "Riley closes the door once and checks the latch.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c014",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Then start with what we know.",
        "sourceDirectionText": "Sam steps back and holds up one finger.",
        "fullDirectionText": "Sam steps back and holds up one finger.",
        "spokenDirectionText": "Step back, finger raised.",
        "beforeGuidanceFields": {
          "directionText": "Sam steps back and holds up one finger.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c015",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "We know the raven was here before rehearsal ended.",
        "sourceDirectionText": "Riley opens the cast photo on a phone.",
        "fullDirectionText": "Riley opens the cast photo on a phone.",
        "spokenDirectionText": "Open the cast photo.",
        "beforeGuidanceFields": {
          "directionText": "Riley opens the cast photo on a phone.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c016",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Can you see it in the picture?",
        "sourceDirectionText": "Sam leans toward the screen without taking it.",
        "fullDirectionText": "Sam leans toward the screen without taking it.",
        "spokenDirectionText": "Lean toward the screen.",
        "beforeGuidanceFields": {
          "directionText": "Sam leans toward the screen without taking it.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c017",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Right there, behind us. Raven, cabinet, terrible pirate hat, all present.",
        "sourceDirectionText": "Riley zooms in.",
        "fullDirectionText": "Riley zooms in.",
        "spokenDirectionText": "Zoom in.",
        "beforeGuidanceFields": {
          "directionText": "Riley zooms in.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c018",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "The pirate hat is innocent. I know that hat personally.",
        "sourceDirectionText": "Sam glances toward the hat rack.",
        "fullDirectionText": "Sam glances toward the hat rack.",
        "spokenDirectionText": "Glance toward the hat.",
        "beforeGuidanceFields": {
          "directionText": "Sam glances toward the hat rack.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c019",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "The photo was at 6:42. I put the raven back a few minutes later.",
        "sourceDirectionText": "Riley reads the time and starts the timeline.",
        "fullDirectionText": "Riley reads the time and starts the timeline.",
        "spokenDirectionText": "Read the time.",
        "beforeGuidanceFields": {
          "directionText": "Riley reads the time and starts the timeline.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c020",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "And I came back for my costume clasp after that.",
        "sourceDirectionText": "Sam touches the loose clasp on a sleeve.",
        "fullDirectionText": "Sam touches the loose clasp on a sleeve.",
        "spokenDirectionText": "Touch the loose clasp.",
        "beforeGuidanceFields": {
          "directionText": "Sam touches the loose clasp on a sleeve.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c021",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "You were here alone?",
        "sourceDirectionText": "Riley asks directly.",
        "fullDirectionText": "Riley asks directly.",
        "spokenDirectionText": "Ask directly.",
        "beforeGuidanceFields": {
          "directionText": "Riley asks directly.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c022",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "For maybe two minutes. I fixed the costume clasp and left.",
        "sourceDirectionText": "Sam shows the small repair.",
        "fullDirectionText": "Sam shows the small repair.",
        "spokenDirectionText": "Show the repair.",
        "beforeGuidanceFields": {
          "directionText": "Sam shows the small repair.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c023",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Did you touch the display case?",
        "sourceDirectionText": "Riley watches Sam closely.",
        "fullDirectionText": "Riley watches Sam closely.",
        "spokenDirectionText": "Watch Sam closely.",
        "beforeGuidanceFields": {
          "directionText": "Riley watches Sam closely.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c024",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "No.",
        "sourceDirectionText": "Sam answers without joking.",
        "fullDirectionText": "Sam answers without joking.",
        "spokenDirectionText": "Answer without joking.",
        "beforeGuidanceFields": {
          "directionText": "Sam answers without joking.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c025",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Did you see anyone else come in?",
        "sourceDirectionText": "Riley looks toward the prop-room door.",
        "fullDirectionText": "Riley looks toward the prop-room door.",
        "spokenDirectionText": "Look toward the door.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks toward the prop-room door.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c026",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "No. But the dance crew rolled the prop cart through twice.",
        "sourceDirectionText": "Sam points toward the cart.",
        "fullDirectionText": "Sam points toward the cart.",
        "spokenDirectionText": "Point toward the cart.",
        "beforeGuidanceFields": {
          "directionText": "Sam points toward the cart.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c027",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "The cart came through before I locked up.",
        "sourceDirectionText": "Riley thinks through the order and shakes Riley's head.",
        "fullDirectionText": "Riley thinks through the order and shakes Riley's head.",
        "spokenDirectionText": "Think through the order.",
        "beforeGuidanceFields": {
          "directionText": "Riley thinks through the order and shakes Riley's head.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c028",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Then maybe we stop guessing that somebody simply walked away with it.",
        "sourceDirectionText": "Sam gestures toward the closed cabinet.",
        "fullDirectionText": "Sam gestures toward the closed cabinet.",
        "spokenDirectionText": "Gesture toward the cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Sam gestures toward the closed cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c029",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "A trophy cannot disappear inside a box.",
        "sourceDirectionText": "Riley says it like the sentence should end the argument.",
        "fullDirectionText": "Riley says it like the sentence should end the argument.",
        "spokenDirectionText": "Speak with finality.",
        "beforeGuidanceFields": {
          "directionText": "Riley says it like the sentence should end the argument.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-c05",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Wait. Look at this dust ring. The trophy definitely sat here after the shelves were cleaned.",
        "sourceDirectionText": "Riley runs one finger around the clean circle in the dust.",
        "fullDirectionText": "Riley runs one finger around the clean circle in the dust.",
        "spokenDirectionText": "Trace the dust circle.",
        "beforeGuidanceFields": {
          "directionText": "Riley runs one finger around the clean circle in the dust.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c031",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "That circle is too clean to be old.",
        "sourceDirectionText": "Sam compares the ring with the dusty shelf.",
        "fullDirectionText": "Sam compares the ring with the dusty shelf.",
        "spokenDirectionText": "Compare ring and shelf.",
        "beforeGuidanceFields": {
          "directionText": "Sam compares the ring with the dusty shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c032",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "So the raven was here. Good. One thing in this room still makes sense.",
        "sourceDirectionText": "Riley records the clue.",
        "fullDirectionText": "Riley records the clue.",
        "spokenDirectionText": "Record the clue.",
        "beforeGuidanceFields": {
          "directionText": "Riley records the clue.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c033",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "I would not celebrate yet. Your display case seems to have swallowed a bird.",
        "sourceDirectionText": "Sam studies the inside.",
        "fullDirectionText": "Sam studies the inside.",
        "spokenDirectionText": "Study the inside.",
        "beforeGuidanceFields": {
          "directionText": "Sam studies the inside.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c034",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Then we figure out how.",
        "sourceDirectionText": "Riley moves closer to the glass.",
        "fullDirectionText": "Riley moves closer to the glass.",
        "spokenDirectionText": "Move closer.",
        "beforeGuidanceFields": {
          "directionText": "Riley moves closer to the glass.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-c06",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "There is a new scratch inside the cabinet, but nothing on the outside. Whatever happened, happened in there.",
        "sourceDirectionText": "Sam points to the fresh mark.",
        "fullDirectionText": "Sam points to the fresh mark.",
        "spokenDirectionText": "Point out fresh mark.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to the fresh mark.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c036",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Inside?",
        "sourceDirectionText": "Riley angles the phone light across the glass.",
        "fullDirectionText": "Riley angles the phone light across the glass.",
        "spokenDirectionText": "Angle phone light.",
        "beforeGuidanceFields": {
          "directionText": "Riley angles the phone light across the glass.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c037",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "See how it starts high and curves down?",
        "sourceDirectionText": "Sam traces the path in the air.",
        "fullDirectionText": "Sam traces the path in the air.",
        "spokenDirectionText": "Trace path in air.",
        "beforeGuidanceFields": {
          "directionText": "Sam traces the path in the air.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c038",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "If somebody simply opened the door, that scratch still needs an explanation.",
        "sourceDirectionText": "Riley looks from the scratch to the lock.",
        "fullDirectionText": "Riley looks from the scratch to the lock.",
        "spokenDirectionText": "Compare scratch and lock.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks from the scratch to the lock.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c039",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Better. We are questioning the cabinet now.",
        "sourceDirectionText": "Sam nods toward it with mock seriousness.",
        "fullDirectionText": "Sam nods toward it with mock seriousness.",
        "spokenDirectionText": "Nod toward it.",
        "beforeGuidanceFields": {
          "directionText": "Sam nods toward it with mock seriousness.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c040",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "I am not questioning furniture.",
        "sourceDirectionText": "Riley gives Sam a look and checks the shelf again.",
        "fullDirectionText": "Riley gives Sam a look and checks the shelf again.",
        "spokenDirectionText": "Give Sam a look.",
        "beforeGuidanceFields": {
          "directionText": "Riley gives Sam a look and checks the shelf again.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c041",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "That is exactly what the furniture wants.",
        "sourceDirectionText": "Sam lets the joke sit for one beat.",
        "fullDirectionText": "Sam lets the joke sit for one beat.",
        "spokenDirectionText": "Pause after the joke.",
        "beforeGuidanceFields": {
          "directionText": "Sam lets the joke sit for one beat.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c042",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Sam.",
        "sourceDirectionText": "Riley gives Sam a warning look.",
        "fullDirectionText": "Riley gives Sam a warning look.",
        "spokenDirectionText": "Give a warning look.",
        "beforeGuidanceFields": {
          "directionText": "Riley gives Sam a warning look.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c043",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Working.",
        "sourceDirectionText": "Sam kneels beside the cabinet.",
        "fullDirectionText": "Sam kneels beside the cabinet.",
        "spokenDirectionText": "Kneel beside the cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Sam kneels beside the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c044",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "I took the raven out for the cast photo.",
        "sourceDirectionText": "Riley restarts the timeline carefully.",
        "fullDirectionText": "Riley restarts the timeline carefully.",
        "spokenDirectionText": "Restart the timeline carefully.",
        "beforeGuidanceFields": {
          "directionText": "Riley restarts the timeline carefully.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c045",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Then you returned it.",
        "sourceDirectionText": "Sam points to the dust ring.",
        "fullDirectionText": "Sam points to the dust ring.",
        "spokenDirectionText": "Point to dust ring.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to the dust ring.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c046",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Yes.",
        "sourceDirectionText": "Riley puts one hand on the shelf and hesitates.",
        "fullDirectionText": "Riley puts one hand on the shelf and hesitates.",
        "spokenDirectionText": "Touch shelf, then hesitate.",
        "beforeGuidanceFields": {
          "directionText": "Riley puts one hand on the shelf and hesitates.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-c07",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "I moved the trophy earlier for the cast photo. When I put it back, the bottom shelf felt loose.",
        "sourceDirectionText": "Riley stops and finally says the missing detail.",
        "fullDirectionText": "Riley stops and finally says the missing detail.",
        "spokenDirectionText": "Reveal the missing detail.",
        "beforeGuidanceFields": {
          "directionText": "Riley stops and finally says the missing detail.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c048",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "You knew the shelf was loose?",
        "sourceDirectionText": "Sam looks at Riley, surprised but not angry.",
        "fullDirectionText": "Sam looks at Riley, surprised but not angry.",
        "spokenDirectionText": "Look at Riley, surprised.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks at Riley, surprised but not angry.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c049",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "I noticed it for about two seconds. Places was called, people were asking me questions, and I thought I would check it later.",
        "sourceDirectionText": "Riley looks back at the loose shelf.",
        "fullDirectionText": "Riley looks back at the loose shelf.",
        "spokenDirectionText": "Look at loose shelf.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks back at the loose shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-c08",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "That is not a tiny detail, Riley. A loose shelf inside a locked cabinet is practically a mystery invitation.",
        "sourceDirectionText": "Sam examines the shelf.",
        "fullDirectionText": "Sam examines the shelf.",
        "spokenDirectionText": "Examine the shelf.",
        "beforeGuidanceFields": {
          "directionText": "Sam examines the shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c051",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "I know.",
        "sourceDirectionText": "Riley presses the shelf gently and feels it shift.",
        "fullDirectionText": "Riley presses the shelf gently and feels it shift.",
        "spokenDirectionText": "Press the shelf gently.",
        "beforeGuidanceFields": {
          "directionText": "Riley presses the shelf gently and feels it shift.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c052",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "How much did it move when you put the raven back?",
        "sourceDirectionText": "Sam watches Riley's hand.",
        "fullDirectionText": "Sam watches Riley's hand.",
        "spokenDirectionText": "Watch Riley's hand.",
        "beforeGuidanceFields": {
          "directionText": "Sam watches Riley's hand.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c053",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Maybe a quarter inch. Enough that I felt it, not enough that I thought the trophy would fall.",
        "sourceDirectionText": "Riley shows the small distance with two fingers.",
        "fullDirectionText": "Riley shows the small distance with two fingers.",
        "spokenDirectionText": "Show with two fingers.",
        "beforeGuidanceFields": {
          "directionText": "Riley shows the small distance with two fingers.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c054",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Did it tilt?",
        "sourceDirectionText": "Sam holds one hand flat like a shelf.",
        "fullDirectionText": "Sam holds one hand flat like a shelf.",
        "spokenDirectionText": "Hold one hand flat.",
        "beforeGuidanceFields": {
          "directionText": "Sam holds one hand flat like a shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c055",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "The back edge dipped. I pushed it level.",
        "sourceDirectionText": "Riley demonstrates the shelf tipping backward.",
        "fullDirectionText": "Riley demonstrates the shelf tipping backward.",
        "spokenDirectionText": "Show shelf tilting backward.",
        "beforeGuidanceFields": {
          "directionText": "Riley demonstrates the shelf tipping backward.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c056",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Back edge. Toward the wall.",
        "sourceDirectionText": "Sam points to the rear of the cabinet.",
        "fullDirectionText": "Sam points to the rear of the cabinet.",
        "spokenDirectionText": "Point to the rear.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to the rear of the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c057",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "You think it slid behind the shelf?",
        "sourceDirectionText": "Riley crouches to look along the back edge.",
        "fullDirectionText": "Riley crouches to look along the back edge.",
        "spokenDirectionText": "Crouch; inspect back edge.",
        "beforeGuidanceFields": {
          "directionText": "Riley crouches to look along the back edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c058",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "I think we should stop deciding what happened before we see what is back there.",
        "sourceDirectionText": "Sam examines the edge from another angle.",
        "fullDirectionText": "Sam examines the edge from another angle.",
        "spokenDirectionText": "Examine the edge.",
        "beforeGuidanceFields": {
          "directionText": "Sam examines the edge from another angle.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c059",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Fair.",
        "sourceDirectionText": "Riley makes room for Sam.",
        "fullDirectionText": "Riley makes room for Sam.",
        "spokenDirectionText": "Make room for Sam.",
        "beforeGuidanceFields": {
          "directionText": "Riley makes room for Sam.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c060",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Also, thank you for saying the shelf thing.",
        "sourceDirectionText": "Sam keeps looking at the cabinet so Riley is not put on the spot.",
        "fullDirectionText": "Sam keeps looking at the cabinet so Riley is not put on the spot.",
        "spokenDirectionText": "Keep looking.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps looking at the cabinet so Riley is not put on the spot.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c061",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "I should have said it five minutes ago.",
        "sourceDirectionText": "Riley checks the shelf supports.",
        "fullDirectionText": "Riley checks the shelf supports.",
        "spokenDirectionText": "Check the shelf supports.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the shelf supports.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c062",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "You said it before we built our whole explanation around the wrong idea. I will take the win.",
        "sourceDirectionText": "Sam gives Riley a small nod.",
        "fullDirectionText": "Sam gives Riley a small nod.",
        "spokenDirectionText": "Give a small nod.",
        "beforeGuidanceFields": {
          "directionText": "Sam gives Riley a small nod.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c063",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Left support is solid.",
        "sourceDirectionText": "Riley checks the left side.",
        "fullDirectionText": "Riley checks the left side.",
        "spokenDirectionText": "Check the left side.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the left side.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c064",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Right support is solid too.",
        "sourceDirectionText": "Sam checks the right side.",
        "fullDirectionText": "Sam checks the right side.",
        "spokenDirectionText": "Check the right side.",
        "beforeGuidanceFields": {
          "directionText": "Sam checks the right side.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c065",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Then why does the back move?",
        "sourceDirectionText": "Riley presses near the rear edge.",
        "fullDirectionText": "Riley presses near the rear edge.",
        "spokenDirectionText": "Press near the rear.",
        "beforeGuidanceFields": {
          "directionText": "Riley presses near the rear edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c066",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Maybe because the cabinet has more hardware than we can see.",
        "sourceDirectionText": "Sam reaches into a costume pocket and pulls out a small magnet.",
        "fullDirectionText": "Sam reaches into a costume pocket and pulls out a small magnet.",
        "spokenDirectionText": "Retrieve the small magnet.",
        "beforeGuidanceFields": {
          "directionText": "Sam reaches into a costume pocket and pulls out a small magnet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c067",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Why do you have a magnet?",
        "sourceDirectionText": "Riley looks from the magnet to Sam.",
        "fullDirectionText": "Riley looks from the magnet to Sam.",
        "spokenDirectionText": "Look: magnet, then Sam.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks from the magnet to Sam.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c068",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Stage magic. Also loose screws. Mostly stage magic.",
        "sourceDirectionText": "Sam holds the magnet between two fingers.",
        "fullDirectionText": "Sam holds the magnet between two fingers.",
        "spokenDirectionText": "Hold magnet between fingers.",
        "beforeGuidanceFields": {
          "directionText": "Sam holds the magnet between two fingers.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c069",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "You carry that around during rehearsal?",
        "sourceDirectionText": "Riley cannot decide whether to be impressed or concerned.",
        "fullDirectionText": "Riley cannot decide whether to be impressed or concerned.",
        "spokenDirectionText": "Look torn, uneasy.",
        "beforeGuidanceFields": {
          "directionText": "Riley cannot decide whether to be impressed or concerned.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c070",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "It has been useful exactly twice. This could be three.",
        "sourceDirectionText": "Sam moves beside the cabinet.",
        "fullDirectionText": "Sam moves beside the cabinet.",
        "spokenDirectionText": "Move beside the cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Sam moves beside the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c071",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Fine. But do not touch the painted trim with it.",
        "sourceDirectionText": "Riley points to the safe edge of the cabinet.",
        "fullDirectionText": "Riley points to the safe edge of the cabinet.",
        "spokenDirectionText": "Point to cabinet edge.",
        "beforeGuidanceFields": {
          "directionText": "Riley points to the safe edge of the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c072",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "I will keep it off the surface.",
        "sourceDirectionText": "Sam holds the magnet a short distance from the visible lock.",
        "fullDirectionText": "Sam holds the magnet a short distance from the visible lock.",
        "spokenDirectionText": "Hold magnet near lock.",
        "beforeGuidanceFields": {
          "directionText": "Sam holds the magnet a short distance from the visible lock.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c073",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Small pull at the lock. Normal.",
        "sourceDirectionText": "Sam lets Riley feel the light tug without touching the cabinet.",
        "fullDirectionText": "Sam lets Riley feel the light tug without touching the cabinet.",
        "spokenDirectionText": "Share tug; avoid contact.",
        "beforeGuidanceFields": {
          "directionText": "Sam lets Riley feel the light tug without touching the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c074",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Try the shelf supports.",
        "sourceDirectionText": "Riley points to the left support.",
        "fullDirectionText": "Riley points to the left support.",
        "spokenDirectionText": "Point to left support.",
        "beforeGuidanceFields": {
          "directionText": "Riley points to the left support.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c075",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Nothing on the left.",
        "sourceDirectionText": "Sam moves the magnet along the outside wall.",
        "fullDirectionText": "Sam moves the magnet along the outside wall.",
        "spokenDirectionText": "Move magnet along outside.",
        "beforeGuidanceFields": {
          "directionText": "Sam moves the magnet along the outside wall.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c076",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Right side?",
        "sourceDirectionText": "Riley crouches beside Sam.",
        "fullDirectionText": "Riley crouches beside Sam.",
        "spokenDirectionText": "Crouch beside Sam.",
        "beforeGuidanceFields": {
          "directionText": "Riley crouches beside Sam.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c077",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Wait.",
        "sourceDirectionText": "Sam stops halfway down the wooden side.",
        "fullDirectionText": "Sam stops halfway down the wooden side.",
        "spokenDirectionText": "Stop halfway down.",
        "beforeGuidanceFields": {
          "directionText": "Sam stops halfway down the wooden side.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c078",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "What?",
        "sourceDirectionText": "Riley follows Sam's hand.",
        "fullDirectionText": "Riley follows Sam's hand.",
        "spokenDirectionText": "Follow Sam's hand.",
        "beforeGuidanceFields": {
          "directionText": "Riley follows Sam's hand.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c079",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "It is pulling harder here than it did at the lock.",
        "sourceDirectionText": "Sam lifts the magnet away and lets it swing back toward the wood.",
        "fullDirectionText": "Sam lifts the magnet away and lets it swing back toward the wood.",
        "spokenDirectionText": "Let magnet swing back.",
        "beforeGuidanceFields": {
          "directionText": "Sam lifts the magnet away and lets it swing back toward the wood.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c080",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Through solid wood?",
        "sourceDirectionText": "Riley taps the side lightly with one knuckle.",
        "fullDirectionText": "Riley taps the side lightly with one knuckle.",
        "spokenDirectionText": "Tap the side lightly.",
        "beforeGuidanceFields": {
          "directionText": "Riley taps the side lightly with one knuckle.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c081",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Something metal is behind it.",
        "sourceDirectionText": "Sam moves the magnet up and down to find the strongest point.",
        "fullDirectionText": "Sam moves the magnet up and down to find the strongest point.",
        "spokenDirectionText": "Scan for strongest pull.",
        "beforeGuidanceFields": {
          "directionText": "Sam moves the magnet up and down to find the strongest point.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c082",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "The case inventory says walnut display cabinet.",
        "sourceDirectionText": "Riley opens the prop inventory on the phone.",
        "fullDirectionText": "Riley opens the prop inventory on the phone.",
        "spokenDirectionText": "Open the prop inventory.",
        "beforeGuidanceFields": {
          "directionText": "Riley opens the prop inventory on the phone.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c083",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "It may be walnut. It may also be lying by omission.",
        "sourceDirectionText": "Sam keeps tracing the magnetic pull.",
        "fullDirectionText": "Sam keeps tracing the magnetic pull.",
        "spokenDirectionText": "Trace magnetic pull.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps tracing the magnetic pull.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c084",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Furniture cannot lie.",
        "sourceDirectionText": "Riley checks the inventory number.",
        "fullDirectionText": "Riley checks the inventory number.",
        "spokenDirectionText": "Check the inventory number.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the inventory number.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c085",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "You said that five minutes ago about disappearing trophies.",
        "sourceDirectionText": "Sam gives Riley a quick look.",
        "fullDirectionText": "Sam gives Riley a quick look.",
        "spokenDirectionText": "Give Riley a look.",
        "beforeGuidanceFields": {
          "directionText": "Sam gives Riley a quick look.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c086",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Fair.",
        "sourceDirectionText": "Riley searches the inventory number again.",
        "fullDirectionText": "Riley searches the inventory number again.",
        "spokenDirectionText": "Search inventory number again.",
        "beforeGuidanceFields": {
          "directionText": "Riley searches the inventory number again.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c087",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Strongest pull right here.",
        "sourceDirectionText": "Sam marks the place with a finger held just off the wood.",
        "fullDirectionText": "Sam marks the place with a finger held just off the wood.",
        "spokenDirectionText": "Hover finger over spot.",
        "beforeGuidanceFields": {
          "directionText": "Sam marks the place with a finger held just off the wood.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c088",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "That is behind the loose shelf.",
        "sourceDirectionText": "Riley lines up the shelf height with Sam's mark.",
        "fullDirectionText": "Riley lines up the shelf height with Sam's mark.",
        "spokenDirectionText": "Align shelf with mark.",
        "beforeGuidanceFields": {
          "directionText": "Riley lines up the shelf height with Sam's mark.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c089",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Which moves the cabinet from suspicious furniture to very suspicious furniture.",
        "sourceDirectionText": "Sam pockets the magnet for a moment.",
        "fullDirectionText": "Sam pockets the magnet for a moment.",
        "spokenDirectionText": "Pocket the magnet briefly.",
        "beforeGuidanceFields": {
          "directionText": "Sam pockets the magnet for a moment.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c090",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "We are not opening anything hidden until we know what this cabinet is.",
        "sourceDirectionText": "Riley scrolls through the old inventory notes.",
        "fullDirectionText": "Riley scrolls through the old inventory notes.",
        "spokenDirectionText": "Scroll old inventory notes.",
        "beforeGuidanceFields": {
          "directionText": "Riley scrolls through the old inventory notes.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c091",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "That sounded like a sentence from a person who just admitted the cabinet might be hidden.",
        "sourceDirectionText": "Sam leans over enough to read.",
        "fullDirectionText": "Sam leans over enough to read.",
        "spokenDirectionText": "Lean over to read.",
        "beforeGuidanceFields": {
          "directionText": "Sam leans over enough to read.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c092",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Here. Old transfer tag.",
        "sourceDirectionText": "Riley stops on a scanned record.",
        "fullDirectionText": "Riley stops on a scanned record.",
        "spokenDirectionText": "Stop on scanned record.",
        "beforeGuidanceFields": {
          "directionText": "Riley stops on a scanned record.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c093",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Read it.",
        "sourceDirectionText": "Sam points to the faded line.",
        "fullDirectionText": "Sam points to the faded line.",
        "spokenDirectionText": "Point at faded line.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to the faded line.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c094",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "\"Merrick stage cabinet. Acquired from alumni storage.\"",
        "sourceDirectionText": "Riley reads slowly.",
        "fullDirectionText": "Riley reads slowly.",
        "spokenDirectionText": "Read slowly.",
        "beforeGuidanceFields": {
          "directionText": "Riley reads slowly.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c095",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Merrick?",
        "sourceDirectionText": "Sam straightens.",
        "fullDirectionText": "Sam straightens.",
        "spokenDirectionText": "Straighten up.",
        "beforeGuidanceFields": {
          "directionText": "Sam straightens.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c096",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "You know the name?",
        "sourceDirectionText": "Riley looks at Sam.",
        "fullDirectionText": "Riley looks at Sam.",
        "spokenDirectionText": "Look at Sam.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks at Sam.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c097",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Merrick the Marvelous. Local illusionist. Old-school cabinets, vanishes, appearance tricks.",
        "sourceDirectionText": "Sam tries not to sound too excited.",
        "fullDirectionText": "Sam tries not to sound too excited.",
        "spokenDirectionText": "Hide your excitement.",
        "beforeGuidanceFields": {
          "directionText": "Sam tries not to sound too excited.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c098",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Please tell me you are making that up.",
        "sourceDirectionText": "Riley looks back at the cabinet.",
        "fullDirectionText": "Riley looks back at the cabinet.",
        "spokenDirectionText": "Look back at cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks back at the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c099",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "I would have picked a better name.",
        "sourceDirectionText": "Sam points to the record.",
        "fullDirectionText": "Sam points to the record.",
        "spokenDirectionText": "Point to the record.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to the record.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c100",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "So this was not built as a trophy case.",
        "sourceDirectionText": "Riley studies the thick side wall.",
        "fullDirectionText": "Riley studies the thick side wall.",
        "spokenDirectionText": "Study the thick side.",
        "beforeGuidanceFields": {
          "directionText": "Riley studies the thick side wall.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c101",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Not originally.",
        "sourceDirectionText": "Sam checks the back edge of the shelf again.",
        "fullDirectionText": "Sam checks the back edge of the shelf again.",
        "spokenDirectionText": "Check the back edge.",
        "beforeGuidanceFields": {
          "directionText": "Sam checks the back edge of the shelf again.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c102",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "That explains hidden metal. It does not explain where the raven went.",
        "sourceDirectionText": "Riley taps the clue list on the phone.",
        "fullDirectionText": "Riley taps the clue list on the phone.",
        "spokenDirectionText": "Tap the clue list.",
        "beforeGuidanceFields": {
          "directionText": "Riley taps the clue list on the phone.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c103",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "It gives us a better question.",
        "sourceDirectionText": "Sam kneels lower.",
        "fullDirectionText": "Sam kneels lower.",
        "spokenDirectionText": "Kneel lower.",
        "beforeGuidanceFields": {
          "directionText": "Sam kneels lower.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c104",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "Which is?",
        "sourceDirectionText": "Riley waits.",
        "fullDirectionText": "Riley waits.",
        "spokenDirectionText": "Wait.",
        "beforeGuidanceFields": {
          "directionText": "Riley waits.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c105",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-1",
        "sourceDialogueText": "What was this cabinet designed to hide?",
        "sourceDirectionText": "Sam studies the wooden side from floor level.",
        "fullDirectionText": "Sam studies the wooden side from floor level.",
        "spokenDirectionText": "Study the wooden side.",
        "beforeGuidanceFields": {
          "directionText": "Sam studies the wooden side from floor level.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c106",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "If there is a compartment, the prop records should mention it.",
        "sourceDirectionText": "Riley searches the transfer notes.",
        "fullDirectionText": "Riley searches the transfer notes.",
        "spokenDirectionText": "Search the transfer notes.",
        "beforeGuidanceFields": {
          "directionText": "Riley searches the transfer notes.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c107",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "A magician selling a trick cabinet may not include \"secret door\" in the public description.",
        "sourceDirectionText": "Sam runs a light across the wood without touching it.",
        "fullDirectionText": "Sam runs a light across the wood without touching it.",
        "spokenDirectionText": "Sweep light across wood.",
        "beforeGuidanceFields": {
          "directionText": "Sam runs a light across the wood without touching it.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c108",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "There is a repair note from twelve years ago. \"Side panel sticking.\"",
        "sourceDirectionText": "Riley enlarges the note.",
        "fullDirectionText": "Riley enlarges the note.",
        "spokenDirectionText": "Enlarge the note.",
        "beforeGuidanceFields": {
          "directionText": "Riley enlarges the note.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c109",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Side panel. Not side wall.",
        "sourceDirectionText": "Sam looks at Riley.",
        "fullDirectionText": "Sam looks at Riley.",
        "spokenDirectionText": "Look at Riley.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks at Riley.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c110",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "That could just be wording.",
        "sourceDirectionText": "Riley turns the phone light along the cabinet edge.",
        "fullDirectionText": "Riley turns the phone light along the cabinet edge.",
        "spokenDirectionText": "Aim light along edge.",
        "beforeGuidanceFields": {
          "directionText": "Riley turns the phone light along the cabinet edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c111",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Or it could be a clue from somebody who knew what this was.",
        "sourceDirectionText": "Sam crouches near the magnetic spot.",
        "fullDirectionText": "Sam crouches near the magnetic spot.",
        "spokenDirectionText": "Crouch near magnetic spot.",
        "beforeGuidanceFields": {
          "directionText": "Sam crouches near the magnetic spot.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c112",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Look for a hinge.",
        "sourceDirectionText": "Riley studies the upper edge.",
        "fullDirectionText": "Riley studies the upper edge.",
        "spokenDirectionText": "Study the upper edge.",
        "beforeGuidanceFields": {
          "directionText": "Riley studies the upper edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c113",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "No visible hinge.",
        "sourceDirectionText": "Sam checks the lower edge.",
        "fullDirectionText": "Sam checks the lower edge.",
        "spokenDirectionText": "Check the lower edge.",
        "beforeGuidanceFields": {
          "directionText": "Sam checks the lower edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c114",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Seam?",
        "sourceDirectionText": "Riley moves the light slowly.",
        "fullDirectionText": "Riley moves the light slowly.",
        "spokenDirectionText": "Move the light slowly.",
        "beforeGuidanceFields": {
          "directionText": "Riley moves the light slowly.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c115",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Nothing obvious.",
        "sourceDirectionText": "Sam changes angles.",
        "fullDirectionText": "Sam changes angles.",
        "spokenDirectionText": "Change your angle.",
        "beforeGuidanceFields": {
          "directionText": "Sam changes angles.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c116",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Wait. Stop there.",
        "sourceDirectionText": "Riley holds Sam's wrist away from the cabinet and angles the phone light across the grain.",
        "fullDirectionText": "Riley holds Sam's wrist away from the cabinet and angles the phone light across the grain.",
        "spokenDirectionText": "Hold Sam's wrist away.",
        "beforeGuidanceFields": {
          "directionText": "Riley holds Sam's wrist away from the cabinet and angles the phone light across the grain.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c117",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "I see it.",
        "sourceDirectionText": "Sam follows a hairline line in the wood with his eyes.",
        "fullDirectionText": "Sam follows a hairline line in the wood with his eyes.",
        "spokenDirectionText": "Follow hairline with eyes.",
        "beforeGuidanceFields": {
          "directionText": "Sam follows a hairline line in the wood with his eyes.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c118",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "It disappears when the light moves.",
        "sourceDirectionText": "Riley shifts the light and finds the seam again.",
        "fullDirectionText": "Riley shifts the light and finds the seam again.",
        "spokenDirectionText": "Shift the light.",
        "beforeGuidanceFields": {
          "directionText": "Riley shifts the light and finds the seam again.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c119",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "That is good cabinet work.",
        "sourceDirectionText": "Sam looks impressed.",
        "fullDirectionText": "Sam looks impressed.",
        "spokenDirectionText": "Look impressed.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks impressed.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c120",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "It is also deeply annoying.",
        "sourceDirectionText": "Riley photographs the seam.",
        "fullDirectionText": "Riley photographs the seam.",
        "spokenDirectionText": "Photograph the seam.",
        "beforeGuidanceFields": {
          "directionText": "Riley photographs the seam.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c121",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "We still need the release.",
        "sourceDirectionText": "Sam takes out the magnet again.",
        "fullDirectionText": "Sam takes out the magnet again.",
        "spokenDirectionText": "Take out the magnet.",
        "beforeGuidanceFields": {
          "directionText": "Sam takes out the magnet again.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c122",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Start where it pulled hardest.",
        "sourceDirectionText": "Riley points to the marked area.",
        "fullDirectionText": "Riley points to the marked area.",
        "spokenDirectionText": "Point to marked area.",
        "beforeGuidanceFields": {
          "directionText": "Riley points to the marked area.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c123",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Holding it close. Not touching.",
        "sourceDirectionText": "Sam brings the magnet near the wood.",
        "fullDirectionText": "Sam brings the magnet near the wood.",
        "spokenDirectionText": "Bring magnet toward wood.",
        "beforeGuidanceFields": {
          "directionText": "Sam brings the magnet near the wood.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c124",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Anything?",
        "sourceDirectionText": "Riley watches the seam.",
        "fullDirectionText": "Riley watches the seam.",
        "spokenDirectionText": "Watch the seam.",
        "beforeGuidanceFields": {
          "directionText": "Riley watches the seam.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c125",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "I felt a click.",
        "sourceDirectionText": "Sam freezes with the magnet held in place",
        "fullDirectionText": "Sam freezes with the magnet held in place",
        "spokenDirectionText": "Freeze with the magnet.",
        "beforeGuidanceFields": {
          "directionText": "Sam freezes with the magnet held in place",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c126",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Do not move the magnet.",
        "sourceDirectionText": "Riley stares at the seam.",
        "fullDirectionText": "Riley stares at the seam.",
        "spokenDirectionText": "Stare at the seam.",
        "beforeGuidanceFields": {
          "directionText": "Riley stares at the seam.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c127",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "I was planning to breathe eventually.",
        "sourceDirectionText": "Sam keeps his hand steady.",
        "fullDirectionText": "Sam keeps his hand steady.",
        "spokenDirectionText": "Hold your hand steady.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps his hand steady.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c128",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "The seam opened at the top.",
        "sourceDirectionText": "Riley angles the light toward the hairline gap.",
        "fullDirectionText": "Riley angles the light toward the hairline gap.",
        "spokenDirectionText": "Angle light toward gap.",
        "beforeGuidanceFields": {
          "directionText": "Riley angles the light toward the hairline gap.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c129",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Then the magnet is the key.",
        "sourceDirectionText": "Sam slowly moves the magnet away.",
        "fullDirectionText": "Sam slowly moves the magnet away.",
        "spokenDirectionText": "Move magnet away slowly.",
        "beforeGuidanceFields": {
          "directionText": "Sam slowly moves the magnet away.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c130",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Closed again.",
        "sourceDirectionText": "Riley watches the seam disappear.",
        "fullDirectionText": "Riley watches the seam disappear.",
        "spokenDirectionText": "Watch the seam disappear.",
        "beforeGuidanceFields": {
          "directionText": "Riley watches the seam disappear.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c131",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Good news. The cabinet is not haunted. It is mechanically dramatic.",
        "sourceDirectionText": "Sam brings the magnet back to the same point.",
        "fullDirectionText": "Sam brings the magnet back to the same point.",
        "spokenDirectionText": "Return magnet to position.",
        "beforeGuidanceFields": {
          "directionText": "Sam brings the magnet back to the same point.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c132",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Open it again.",
        "sourceDirectionText": "Riley keeps the phone camera ready.",
        "fullDirectionText": "Riley keeps the phone camera ready.",
        "spokenDirectionText": "Ready the phone camera.",
        "beforeGuidanceFields": {
          "directionText": "Riley keeps the phone camera ready.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c133",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Click.",
        "sourceDirectionText": "Sam holds the magnet in place.",
        "fullDirectionText": "Sam holds the magnet in place.",
        "spokenDirectionText": "Hold the magnet.",
        "beforeGuidanceFields": {
          "directionText": "Sam holds the magnet in place.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c134",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "There.",
        "sourceDirectionText": "Riley presses only the edge that lifted.",
        "fullDirectionText": "Riley presses only the edge that lifted.",
        "spokenDirectionText": "Press only lifted edge.",
        "beforeGuidanceFields": {
          "directionText": "Riley presses only the edge that lifted.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c136",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Hidden compartment.",
        "sourceDirectionText": "Riley shines the light into the opening.",
        "fullDirectionText": "Riley shines the light into the opening.",
        "spokenDirectionText": "Shine light inside.",
        "beforeGuidanceFields": {
          "directionText": "Riley shines the light into the opening.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c137",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Merrick, you ridiculous genius.",
        "sourceDirectionText": "Sam peers in from beside Riley.",
        "fullDirectionText": "Sam peers in from beside Riley.",
        "spokenDirectionText": "Peer into open compartment.",
        "beforeGuidanceFields": {
          "directionText": "Sam peers in from beside Riley.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c138",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Empty.",
        "sourceDirectionText": "Riley's excitement drops.",
        "fullDirectionText": "Riley's excitement drops.",
        "spokenDirectionText": "Let excitement fade.",
        "beforeGuidanceFields": {
          "directionText": "Riley's excitement drops.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c139",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Completely?",
        "sourceDirectionText": "Sam changes angle.",
        "fullDirectionText": "Sam changes angle.",
        "spokenDirectionText": "Change your viewing angle.",
        "beforeGuidanceFields": {
          "directionText": "Sam changes angle.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c140",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Dust. Old felt. No raven.",
        "sourceDirectionText": "Riley photographs the compartment.",
        "fullDirectionText": "Riley photographs the compartment.",
        "spokenDirectionText": "Photograph the compartment.",
        "beforeGuidanceFields": {
          "directionText": "Riley photographs the compartment.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c141",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "We found the trick and still did not find the trophy.",
        "sourceDirectionText": "Sam sits back on his heels.",
        "fullDirectionText": "Sam sits back on his heels.",
        "spokenDirectionText": "Sit back on heels.",
        "beforeGuidanceFields": {
          "directionText": "Sam sits back on his heels.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c142",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "That is not funny.",
        "sourceDirectionText": "Riley looks at the director's return time on the phone.",
        "fullDirectionText": "Riley looks at the director's return time on the phone.",
        "spokenDirectionText": "Check director return time.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks at the director's return time on the phone.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c143",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "I was not joking.",
        "sourceDirectionText": "Sam looks at the empty compartment again.",
        "fullDirectionText": "Sam looks at the empty compartment again.",
        "spokenDirectionText": "Look inside again.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks at the empty compartment again.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c144",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "The director is back in less than an hour.",
        "sourceDirectionText": "Riley shuts off the phone screen.",
        "fullDirectionText": "Riley shuts off the phone screen.",
        "spokenDirectionText": "Turn off phone screen.",
        "beforeGuidanceFields": {
          "directionText": "Riley shuts off the phone screen.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c145",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Then we keep going.",
        "sourceDirectionText": "Sam reaches for the light.",
        "fullDirectionText": "Sam reaches for the light.",
        "spokenDirectionText": "Reach for the light.",
        "beforeGuidanceFields": {
          "directionText": "Sam reaches for the light.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c146",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "We proved the cabinet can hide things. We did not prove it hid the raven.",
        "sourceDirectionText": "Riley lists the facts with a finger.",
        "fullDirectionText": "Riley lists the facts with a finger.",
        "spokenDirectionText": "List facts with finger.",
        "beforeGuidanceFields": {
          "directionText": "Riley lists the facts with a finger.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c147",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "True.",
        "sourceDirectionText": "Sam studies the felt lining.",
        "fullDirectionText": "Sam studies the felt lining.",
        "spokenDirectionText": "Study the felt lining.",
        "beforeGuidanceFields": {
          "directionText": "Sam studies the felt lining.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c148",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "And if somebody knew about this compartment, someone could still have moved it.",
        "sourceDirectionText": "Riley looks toward the prop-room door.",
        "fullDirectionText": "Riley looks toward the prop-room door.",
        "spokenDirectionText": "Look toward the door.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks toward the prop-room door.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c149",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Also true.",
        "sourceDirectionText": "Sam does not argue.",
        "fullDirectionText": "Sam does not argue.",
        "spokenDirectionText": "Don't argue.",
        "beforeGuidanceFields": {
          "directionText": "Sam does not argue.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c150",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "I hate when you agree that fast.",
        "sourceDirectionText": "Riley exhales and looks back inside.",
        "fullDirectionText": "Riley exhales and looks back inside.",
        "spokenDirectionText": "Exhale, inspect inside.",
        "beforeGuidanceFields": {
          "directionText": "Riley exhales and looks back inside.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c151",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "It usually means the next clue has to do more work.",
        "sourceDirectionText": "Sam shines the light along the compartment floor.",
        "fullDirectionText": "Sam shines the light along the compartment floor.",
        "spokenDirectionText": "Illuminate the compartment floor.",
        "beforeGuidanceFields": {
          "directionText": "Sam shines the light along the compartment floor.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c152",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Wait. Lower right corner.",
        "sourceDirectionText": "Riley points inside without reaching in.",
        "fullDirectionText": "Riley points inside without reaching in.",
        "spokenDirectionText": "Point inside without reaching.",
        "beforeGuidanceFields": {
          "directionText": "Riley points inside without reaching in.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c153",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Scuff mark.",
        "sourceDirectionText": "Sam angles the light.",
        "fullDirectionText": "Sam angles the light.",
        "spokenDirectionText": "Angle the light.",
        "beforeGuidanceFields": {
          "directionText": "Sam angles the light.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c154",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Fresh?",
        "sourceDirectionText": "Riley compares it to the older dust.",
        "fullDirectionText": "Riley compares it to the older dust.",
        "spokenDirectionText": "Compare against older dust.",
        "beforeGuidanceFields": {
          "directionText": "Riley compares it to the older dust.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c155",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Looks fresher than the felt around it.",
        "sourceDirectionText": "Sam traces the curve in the air.",
        "fullDirectionText": "Sam traces the curve in the air.",
        "spokenDirectionText": "Trace curve in air.",
        "beforeGuidanceFields": {
          "directionText": "Sam traces the curve in the air.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c156",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "It bends downward.",
        "sourceDirectionText": "Riley follows the mark to the bottom edge.",
        "fullDirectionText": "Riley follows the mark to the bottom edge.",
        "spokenDirectionText": "Follow mark to bottom.",
        "beforeGuidanceFields": {
          "directionText": "Riley follows the mark to the bottom edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c157",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Like something slid through here and kept going.",
        "sourceDirectionText": "Sam looks below the open compartment.",
        "fullDirectionText": "Sam looks below the open compartment.",
        "spokenDirectionText": "Look below open compartment.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks below the open compartment.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c158",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Kept going where?",
        "sourceDirectionText": "Riley crouches lower.",
        "fullDirectionText": "Riley crouches lower.",
        "spokenDirectionText": "Crouch lower.",
        "beforeGuidanceFields": {
          "directionText": "Riley crouches lower.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c159",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "That is our new question.",
        "sourceDirectionText": "Sam checks the outside base.",
        "fullDirectionText": "Sam checks the outside base.",
        "spokenDirectionText": "Check the outside base.",
        "beforeGuidanceFields": {
          "directionText": "Sam checks the outside base.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c160",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "The cabinet floor looks solid.",
        "sourceDirectionText": "Riley taps the visible bottom from outside.",
        "fullDirectionText": "Riley taps the visible bottom from outside.",
        "spokenDirectionText": "Tap the visible bottom.",
        "beforeGuidanceFields": {
          "directionText": "Riley taps the visible bottom from outside.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c161",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "The side looked solid too.",
        "sourceDirectionText": "Sam studies the lower cabinet.",
        "fullDirectionText": "Sam studies the lower cabinet.",
        "spokenDirectionText": "Study the lower cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Sam studies the lower cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c162",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-2",
        "sourceDialogueText": "Fair point.",
        "sourceDirectionText": "Riley moves the light toward the base.",
        "fullDirectionText": "Riley moves the light toward the base.",
        "spokenDirectionText": "Aim light toward base.",
        "beforeGuidanceFields": {
          "directionText": "Riley moves the light toward the base.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c163",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "The pull is weaker down here.",
        "sourceDirectionText": "Sam checks the lower side.",
        "fullDirectionText": "Sam checks the lower side.",
        "spokenDirectionText": "Check the lower side.",
        "beforeGuidanceFields": {
          "directionText": "Sam checks the lower side.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c164",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Try the back edge.",
        "sourceDirectionText": "Riley points beneath the compartment.",
        "fullDirectionText": "Riley points beneath the compartment.",
        "spokenDirectionText": "Point beneath the compartment.",
        "beforeGuidanceFields": {
          "directionText": "Riley points beneath the compartment.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c165",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Nothing there.",
        "sourceDirectionText": "Sam moves slowly.",
        "fullDirectionText": "Sam moves slowly.",
        "spokenDirectionText": "Move slowly.",
        "beforeGuidanceFields": {
          "directionText": "Sam moves slowly.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c166",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Front edge?",
        "sourceDirectionText": "Riley shifts to give Sam room.",
        "fullDirectionText": "Riley shifts to give Sam room.",
        "spokenDirectionText": "Shift; give Sam room.",
        "beforeGuidanceFields": {
          "directionText": "Riley shifts to give Sam room.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c167",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Still nothing.",
        "sourceDirectionText": "Sam checks the cabinet base again.",
        "fullDirectionText": "Sam checks the cabinet base again.",
        "spokenDirectionText": "Check the cabinet base.",
        "beforeGuidanceFields": {
          "directionText": "Sam checks the cabinet base again.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c168",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "The scuff goes down, but we have not found the next opening.",
        "sourceDirectionText": "Riley looks from the mark to the shelf.",
        "fullDirectionText": "Riley looks from the mark to the shelf.",
        "spokenDirectionText": "Look: mark, then shelf.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks from the mark to the shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c169",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Then maybe the shelf moves another part.",
        "sourceDirectionText": "Sam studies the back edge.",
        "fullDirectionText": "Sam studies the back edge.",
        "spokenDirectionText": "Study the back edge.",
        "beforeGuidanceFields": {
          "directionText": "Sam studies the back edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c170",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Show me exactly what you mean.",
        "sourceDirectionText": "Riley steps beside Sam.",
        "fullDirectionText": "Riley steps beside Sam.",
        "spokenDirectionText": "Step beside Sam.",
        "beforeGuidanceFields": {
          "directionText": "Riley steps beside Sam.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c171",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Show me how the shelf moved when you returned the raven.",
        "sourceDirectionText": "Sam keeps both hands clear.",
        "fullDirectionText": "Sam keeps both hands clear.",
        "spokenDirectionText": "Keep both hands clear.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps both hands clear.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c172",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "The back edge dipped, then I pushed it level.",
        "sourceDirectionText": "Riley demonstrates gently.",
        "fullDirectionText": "Riley demonstrates gently.",
        "spokenDirectionText": "Demonstrate gently.",
        "beforeGuidanceFields": {
          "directionText": "Riley demonstrates gently.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c173",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Did you hear anything when it dipped?",
        "sourceDirectionText": "Sam watches the cabinet.",
        "fullDirectionText": "Sam watches the cabinet.",
        "spokenDirectionText": "Watch the cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Sam watches the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c174",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "I do not remember. Rehearsal was loud.",
        "sourceDirectionText": "Riley thinks back.",
        "fullDirectionText": "Riley thinks back.",
        "spokenDirectionText": "Think back.",
        "beforeGuidanceFields": {
          "directionText": "Riley thinks back.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c175",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "People were moving scenery then, right?",
        "sourceDirectionText": "Sam looks toward the prop cart.",
        "fullDirectionText": "Sam looks toward the prop cart.",
        "spokenDirectionText": "Look toward prop cart.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks toward the prop cart.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c176",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Constantly.",
        "sourceDirectionText": "Riley follows Sam's look.",
        "fullDirectionText": "Riley follows Sam's look.",
        "spokenDirectionText": "Follow Sam's look.",
        "beforeGuidanceFields": {
          "directionText": "Riley follows Sam's look.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c177",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "The cart came through twice.",
        "sourceDirectionText": "Sam points to one wheel.",
        "fullDirectionText": "Sam points to one wheel.",
        "spokenDirectionText": "Point to one wheel.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to one wheel.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c178",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Second pass was after the cast photo.",
        "sourceDirectionText": "Riley checks the photo time.",
        "fullDirectionText": "Riley checks the photo time.",
        "spokenDirectionText": "Check the photo time.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the photo time.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c179",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "After you put the raven back?",
        "sourceDirectionText": "Sam asks carefully.",
        "fullDirectionText": "Sam asks carefully.",
        "spokenDirectionText": "Ask carefully.",
        "beforeGuidanceFields": {
          "directionText": "Sam asks carefully.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c180",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Yes.",
        "sourceDirectionText": "Riley's face changes.",
        "fullDirectionText": "Riley's face changes.",
        "spokenDirectionText": "Let your face change.",
        "beforeGuidanceFields": {
          "directionText": "Riley's face changes.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c181",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Did the cart bump this cabinet?",
        "sourceDirectionText": "Sam looks at the narrow aisle.",
        "fullDirectionText": "Sam looks at the narrow aisle.",
        "spokenDirectionText": "Look down narrow aisle.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks at the narrow aisle.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c182",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "I do not know yet.",
        "sourceDirectionText": "Riley searches the memory instead of guessing.",
        "fullDirectionText": "Riley searches the memory instead of guessing.",
        "spokenDirectionText": "Recall without guessing.",
        "beforeGuidanceFields": {
          "directionText": "Riley searches the memory instead of guessing.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c183",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "I remember somebody saying, \"Watch the corner.\"",
        "sourceDirectionText": "Sam points toward the aisle.",
        "fullDirectionText": "Sam points toward the aisle.",
        "spokenDirectionText": "Point toward the aisle.",
        "beforeGuidanceFields": {
          "directionText": "Sam points toward the aisle.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c184",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "I said that.",
        "sourceDirectionText": "Riley looks at the cart handle.",
        "fullDirectionText": "Riley looks at the cart handle.",
        "spokenDirectionText": "Look at cart handle.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks at the cart handle.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c185",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Why?",
        "sourceDirectionText": "Sam waits.",
        "fullDirectionText": "Sam waits.",
        "spokenDirectionText": "Wait.",
        "beforeGuidanceFields": {
          "directionText": "Sam waits.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c186",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Because the back caster swung wide.",
        "sourceDirectionText": "Riley walks the cart path with Riley's eyes.",
        "fullDirectionText": "Riley walks the cart path with Riley's eyes.",
        "spokenDirectionText": "Trace cart path visually.",
        "beforeGuidanceFields": {
          "directionText": "Riley walks the cart path with Riley's eyes.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c187",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "What did it hit?",
        "sourceDirectionText": "Sam follows the line.",
        "fullDirectionText": "Sam follows the line.",
        "spokenDirectionText": "Follow the line.",
        "beforeGuidanceFields": {
          "directionText": "Sam follows the line.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c188",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "This side.",
        "sourceDirectionText": "Riley points low on the cabinet.",
        "fullDirectionText": "Riley points low on the cabinet.",
        "spokenDirectionText": "Point low.",
        "beforeGuidanceFields": {
          "directionText": "Riley points low on the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c189",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Hard?",
        "sourceDirectionText": "Sam crouches near the spot.",
        "fullDirectionText": "Sam crouches near the spot.",
        "spokenDirectionText": "Crouch near the spot.",
        "beforeGuidanceFields": {
          "directionText": "Sam crouches near the spot.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c190",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Not enough to stop rehearsal. Enough that I looked over.",
        "sourceDirectionText": "Riley checks the wood for a fresh mark.",
        "fullDirectionText": "Riley checks the wood for a fresh mark.",
        "spokenDirectionText": "Check the wood.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the wood for a fresh mark.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c191",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "There. Fresh gray mark on the base trim.",
        "sourceDirectionText": "Sam points without touching it.",
        "fullDirectionText": "Sam points without touching it.",
        "spokenDirectionText": "Point without touching it.",
        "beforeGuidanceFields": {
          "directionText": "Sam points without touching it.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c192",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Same height as the cart axle.",
        "sourceDirectionText": "Riley compares the mark to the nearest cart wheel.",
        "fullDirectionText": "Riley compares the mark to the nearest cart wheel.",
        "spokenDirectionText": "Compare mark with cart-wheel.",
        "beforeGuidanceFields": {
          "directionText": "Riley compares the mark to the nearest cart wheel.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c193",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "So the cart really did hit it.",
        "sourceDirectionText": "Sam looks back at the cabinet.",
        "fullDirectionText": "Sam looks back at the cabinet.",
        "spokenDirectionText": "Look back at cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks back at the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c194",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "That gives us a bump. It does not give us a missing trophy.",
        "sourceDirectionText": "Riley keeps the clue list open.",
        "fullDirectionText": "Riley keeps the clue list open.",
        "spokenDirectionText": "Keep clue list open.",
        "beforeGuidanceFields": {
          "directionText": "Riley keeps the clue list open.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c195",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Unless the bump moved the shelf.",
        "sourceDirectionText": "Sam points to the loose back edge.",
        "fullDirectionText": "Sam points to the loose back edge.",
        "spokenDirectionText": "Point to loose back-edge.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to the loose back edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c196",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "And the shelf moved something below it.",
        "sourceDirectionText": "Riley follows the line down the cabinet.",
        "fullDirectionText": "Riley follows the line down the cabinet.",
        "spokenDirectionText": "Follow the line down.",
        "beforeGuidanceFields": {
          "directionText": "Riley follows the line down the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c197",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Let us test the shelf without the raven.",
        "sourceDirectionText": "Sam keeps both hands visible and waits.",
        "fullDirectionText": "Sam keeps both hands visible and waits.",
        "spokenDirectionText": "Keep both hands visible.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps both hands visible and waits.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c198",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Slowly.",
        "sourceDirectionText": "Riley presses the back edge with one finger.",
        "fullDirectionText": "Riley presses the back edge with one finger.",
        "spokenDirectionText": "Press the back edge.",
        "beforeGuidanceFields": {
          "directionText": "Riley presses the back edge with one finger.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c200",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "I heard a click.",
        "sourceDirectionText": "Sam freezes.",
        "fullDirectionText": "Sam freezes.",
        "spokenDirectionText": "Freeze.",
        "beforeGuidanceFields": {
          "directionText": "Sam freezes.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c201",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "From the side panel?",
        "sourceDirectionText": "Riley checks the open compartment.",
        "fullDirectionText": "Riley checks the open compartment.",
        "spokenDirectionText": "Check the open compartment.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the open compartment.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c202",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Lower.",
        "sourceDirectionText": "Sam points toward the base.",
        "fullDirectionText": "Sam points toward the base.",
        "spokenDirectionText": "Point toward the base.",
        "beforeGuidanceFields": {
          "directionText": "Sam points toward the base.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c203",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Do it again.",
        "sourceDirectionText": "Riley resets the shelf carefully.",
        "fullDirectionText": "Riley resets the shelf carefully.",
        "spokenDirectionText": "Reset shelf carefully.",
        "beforeGuidanceFields": {
          "directionText": "Riley resets the shelf carefully.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c204",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Ready.",
        "sourceDirectionText": "Sam moves near the cabinet base.",
        "fullDirectionText": "Sam moves near the cabinet base.",
        "spokenDirectionText": "Move beside cabinet base.",
        "beforeGuidanceFields": {
          "directionText": "Sam moves near the cabinet base.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c205",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Pressing.",
        "sourceDirectionText": "Riley dips the shelf again.",
        "fullDirectionText": "Riley dips the shelf again.",
        "spokenDirectionText": "Dip the shelf again.",
        "beforeGuidanceFields": {
          "directionText": "Riley dips the shelf again.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c206",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Click. Lower right.",
        "sourceDirectionText": "Sam taps the floor beside the cabinet, not the wood.",
        "fullDirectionText": "Sam taps the floor beside the cabinet, not the wood.",
        "spokenDirectionText": "Tap the floor.",
        "beforeGuidanceFields": {
          "directionText": "Sam taps the floor beside the cabinet, not the wood.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c207",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "That is near the cart mark.",
        "sourceDirectionText": "Riley crouches lower.",
        "fullDirectionText": "Riley crouches lower.",
        "spokenDirectionText": "Crouch lower.",
        "beforeGuidanceFields": {
          "directionText": "Riley crouches lower.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c208",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Maybe the bump jarred a second catch.",
        "sourceDirectionText": "Sam takes out the magnet.",
        "fullDirectionText": "Sam takes out the magnet.",
        "spokenDirectionText": "Take out the magnet.",
        "beforeGuidanceFields": {
          "directionText": "Sam takes out the magnet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c209",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "We need to know where before you start fishing around.",
        "sourceDirectionText": "Riley shines the light along the base.",
        "fullDirectionText": "Riley shines the light along the base.",
        "spokenDirectionText": "Shine light along base.",
        "beforeGuidanceFields": {
          "directionText": "Riley shines the light along the base.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c210",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Agreed.",
        "sourceDirectionText": "Sam holds the magnet away from the cabinet.",
        "fullDirectionText": "Sam holds the magnet away from the cabinet.",
        "spokenDirectionText": "Hold the magnet away.",
        "beforeGuidanceFields": {
          "directionText": "Sam holds the magnet away from the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c211",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "I see another seam.",
        "sourceDirectionText": "Riley moves the light sideways across the bottom trim.",
        "fullDirectionText": "Riley moves the light sideways across the bottom trim.",
        "spokenDirectionText": "Move the light sideways.",
        "beforeGuidanceFields": {
          "directionText": "Riley moves the light sideways across the bottom trim.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c212",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Where?",
        "sourceDirectionText": "Sam lowers to Riley's eye level.",
        "fullDirectionText": "Sam lowers to Riley's eye level.",
        "spokenDirectionText": "Lower to Riley's eye-level.",
        "beforeGuidanceFields": {
          "directionText": "Sam lowers to Riley's eye level.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c213",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Two inches above the floor. It runs under the first compartment.",
        "sourceDirectionText": "Riley traces the seam in the air.",
        "fullDirectionText": "Riley traces the seam in the air.",
        "spokenDirectionText": "Trace seam in air.",
        "beforeGuidanceFields": {
          "directionText": "Riley traces the seam in the air.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c214",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "That could be a second panel.",
        "sourceDirectionText": "Sam studies both ends.",
        "fullDirectionText": "Sam studies both ends.",
        "spokenDirectionText": "Study both ends.",
        "beforeGuidanceFields": {
          "directionText": "Sam studies both ends.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c215",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Or a repair line.",
        "sourceDirectionText": "Riley photographs it.",
        "fullDirectionText": "Riley photographs it.",
        "spokenDirectionText": "Photograph it.",
        "beforeGuidanceFields": {
          "directionText": "Riley photographs it.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c216",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Let the magnet vote.",
        "sourceDirectionText": "Sam waits for permission.",
        "fullDirectionText": "Sam waits for permission.",
        "spokenDirectionText": "Wait for permission.",
        "beforeGuidanceFields": {
          "directionText": "Sam waits for permission.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c217",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Go ahead. Same rule. No contact with the finish.",
        "sourceDirectionText": "Riley watches the seam.",
        "fullDirectionText": "Riley watches the seam.",
        "spokenDirectionText": "Watch the seam.",
        "beforeGuidanceFields": {
          "directionText": "Riley watches the seam.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c218",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Weak pull.",
        "sourceDirectionText": "Sam moves the magnet from left to right.",
        "fullDirectionText": "Sam moves the magnet from left to right.",
        "spokenDirectionText": "Sweep magnet left-to-right.",
        "beforeGuidanceFields": {
          "directionText": "Sam moves the magnet from left to right.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c219",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Keep going.",
        "sourceDirectionText": "Riley follows the magnet with the light.",
        "fullDirectionText": "Riley follows the magnet with the light.",
        "spokenDirectionText": "Follow magnet with light.",
        "beforeGuidanceFields": {
          "directionText": "Riley follows the magnet with the light.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c220",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-3",
        "sourceDialogueText": "Stronger.",
        "sourceDirectionText": "Sam slows near the right corner.",
        "fullDirectionText": "Sam slows near the right corner.",
        "spokenDirectionText": "Slow near right corner.",
        "beforeGuidanceFields": {
          "directionText": "Sam slows near the right corner.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c221",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Very strong here.",
        "sourceDirectionText": "Sam stops near the base trim.",
        "fullDirectionText": "Sam stops near the base trim.",
        "spokenDirectionText": "Stop near base trim.",
        "beforeGuidanceFields": {
          "directionText": "Sam stops near the base trim.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c222",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Same spot as the impact mark.",
        "sourceDirectionText": "Riley compares both clues.",
        "fullDirectionText": "Riley compares both clues.",
        "spokenDirectionText": "Compare both clues.",
        "beforeGuidanceFields": {
          "directionText": "Riley compares both clues.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c223",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "That is convenient.",
        "sourceDirectionText": "Sam gives the cabinet a suspicious look.",
        "fullDirectionText": "Sam gives the cabinet a suspicious look.",
        "spokenDirectionText": "Give cabinet suspicious look.",
        "beforeGuidanceFields": {
          "directionText": "Sam gives the cabinet a suspicious look.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c224",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Do not insult it until we know what it does.",
        "sourceDirectionText": "Riley braces the phone camera.",
        "fullDirectionText": "Riley braces the phone camera.",
        "spokenDirectionText": "Brace the phone camera.",
        "beforeGuidanceFields": {
          "directionText": "Riley braces the phone camera.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c225",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Holding the magnet close.",
        "sourceDirectionText": "Sam brings it near the wood.",
        "fullDirectionText": "Sam brings it near the wood.",
        "spokenDirectionText": "Bring magnet near wood.",
        "beforeGuidanceFields": {
          "directionText": "Sam brings it near the wood.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c227",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "The right edge moved.",
        "sourceDirectionText": "Riley points to a hairline gap.",
        "fullDirectionText": "Riley points to a hairline gap.",
        "spokenDirectionText": "Point to hairline gap.",
        "beforeGuidanceFields": {
          "directionText": "Riley points to a hairline gap.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c228",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "I am not touching it.",
        "sourceDirectionText": "Sam keeps the magnet steady.",
        "fullDirectionText": "Sam keeps the magnet steady.",
        "spokenDirectionText": "Keep the magnet steady.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps the magnet steady.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c229",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Good. I will open it.",
        "sourceDirectionText": "Riley slips one fingertip under the released edge.",
        "fullDirectionText": "Riley slips one fingertip under the released edge.",
        "spokenDirectionText": "Slip fingertip under edge.",
        "beforeGuidanceFields": {
          "directionText": "Riley slips one fingertip under the released edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c230",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "It is heavier than the first panel.",
        "sourceDirectionText": "Riley pulls carefully.",
        "fullDirectionText": "Riley pulls carefully.",
        "spokenDirectionText": "Pull carefully.",
        "beforeGuidanceFields": {
          "directionText": "Riley pulls carefully.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c231",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Hinge underneath?",
        "sourceDirectionText": "Sam watches the bottom edge.",
        "fullDirectionText": "Sam watches the bottom edge.",
        "spokenDirectionText": "Watch the bottom edge.",
        "beforeGuidanceFields": {
          "directionText": "Sam watches the bottom edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c232",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Yes.",
        "sourceDirectionText": "Riley lowers the narrow panel like a small door.",
        "fullDirectionText": "Riley lowers the narrow panel like a small door.",
        "spokenDirectionText": "Lower the narrow panel.",
        "beforeGuidanceFields": {
          "directionText": "Riley lowers the narrow panel like a small door.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c234",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Please contain one brass bird.",
        "sourceDirectionText": "Sam leans closer.",
        "fullDirectionText": "Sam leans closer.",
        "spokenDirectionText": "Lean closer.",
        "beforeGuidanceFields": {
          "directionText": "Sam leans closer.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c235",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "I see felt.",
        "sourceDirectionText": "Riley shines the light inside.",
        "fullDirectionText": "Riley shines the light inside.",
        "spokenDirectionText": "Shine light inside.",
        "beforeGuidanceFields": {
          "directionText": "Riley shines the light inside.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c236",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "And?",
        "sourceDirectionText": "Sam waits.",
        "fullDirectionText": "Sam waits.",
        "spokenDirectionText": "Wait.",
        "beforeGuidanceFields": {
          "directionText": "Sam waits.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c237",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "No raven.",
        "sourceDirectionText": "Riley's shoulders drop.",
        "fullDirectionText": "Riley's shoulders drop.",
        "spokenDirectionText": "Riley's shoulders drop.",
        "beforeGuidanceFields": {
          "directionText": "Riley's shoulders drop.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c238",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "That would have been too easy.",
        "sourceDirectionText": "Sam looks at the chamber floor.",
        "fullDirectionText": "Sam looks at the chamber floor.",
        "spokenDirectionText": "Look at chamber floor.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks at the chamber floor.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c239",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "We are standing inside the answer and still missing it.",
        "sourceDirectionText": "Riley checks the director's return time.",
        "fullDirectionText": "Riley checks the director's return time.",
        "spokenDirectionText": "Check director's return time.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the director's return time.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c240",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Then the answer has another layer.",
        "sourceDirectionText": "Sam studies the back of the chamber.",
        "fullDirectionText": "Sam studies the back of the chamber.",
        "spokenDirectionText": "Study back of chamber.",
        "beforeGuidanceFields": {
          "directionText": "Sam studies the back of the chamber.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c241",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "The felt is folded here.",
        "sourceDirectionText": "Riley points to a raised edge.",
        "fullDirectionText": "Riley points to a raised edge.",
        "spokenDirectionText": "Point to raised edge.",
        "beforeGuidanceFields": {
          "directionText": "Riley points to a raised edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c242",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Do not pull it yet.",
        "sourceDirectionText": "Sam stops Riley gently with a word.",
        "fullDirectionText": "Sam stops Riley gently with a word.",
        "spokenDirectionText": "Stop Riley verbally, gently.",
        "beforeGuidanceFields": {
          "directionText": "Sam stops Riley gently with a word.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c243",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "I was not going to.",
        "sourceDirectionText": "Riley photographs the fold first.",
        "fullDirectionText": "Riley photographs the fold first.",
        "spokenDirectionText": "Photograph the fold first.",
        "beforeGuidanceFields": {
          "directionText": "Riley photographs the fold first.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c244",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Good. I enjoy having a stage manager who learns during the mystery.",
        "sourceDirectionText": "Sam smiles once.",
        "fullDirectionText": "Sam smiles once.",
        "spokenDirectionText": "Smile once.",
        "beforeGuidanceFields": {
          "directionText": "Sam smiles once.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c245",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Keep enjoying it quietly.",
        "sourceDirectionText": "Riley angles the light.",
        "fullDirectionText": "Riley angles the light.",
        "spokenDirectionText": "Angle the light.",
        "beforeGuidanceFields": {
          "directionText": "Riley angles the light.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c246",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "There is a curved scratch on the felt too.",
        "sourceDirectionText": "Sam points to a silver-gray line.",
        "fullDirectionText": "Sam points to a silver-gray line.",
        "spokenDirectionText": "Point to silver-gray line.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to a silver-gray line.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c247",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Same shape as the scuff above.",
        "sourceDirectionText": "Riley compares the photo.",
        "fullDirectionText": "Riley compares the photo.",
        "spokenDirectionText": "Compare the photo.",
        "beforeGuidanceFields": {
          "directionText": "Riley compares the photo.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c248",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "That means something passed through both spaces.",
        "sourceDirectionText": "Sam follows the curve downward with one finger in the air.",
        "fullDirectionText": "Sam follows the curve downward with one finger in the air.",
        "spokenDirectionText": "Trace downward in air.",
        "beforeGuidanceFields": {
          "directionText": "Sam follows the curve downward with one finger in the air.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c249",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "The first compartment is not storage. It is a path.",
        "sourceDirectionText": "Riley looks up at the loose shelf.",
        "fullDirectionText": "Riley looks up at the loose shelf.",
        "spokenDirectionText": "Look toward loose shelf.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks up at the loose shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c250",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "A magician's load path.",
        "sourceDirectionText": "Sam finally sounds certain.",
        "fullDirectionText": "Sam finally sounds certain.",
        "spokenDirectionText": "Speak with certainty.",
        "beforeGuidanceFields": {
          "directionText": "Sam finally sounds certain.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c251",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Explain that without turning this into a lecture.",
        "sourceDirectionText": "Riley stays focused on the cabinet.",
        "fullDirectionText": "Riley stays focused on the cabinet.",
        "spokenDirectionText": "Focus on the cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Riley stays focused on the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c252",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Object drops behind the shelf, passes the hidden side space, then lands lower where the audience cannot see it.",
        "sourceDirectionText": "Sam traces the route in three short motions.",
        "fullDirectionText": "Sam traces the route in three short motions.",
        "spokenDirectionText": "Trace the route.",
        "beforeGuidanceFields": {
          "directionText": "Sam traces the route in three short motions.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c253",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "So the raven could have fallen without leaving the cabinet.",
        "sourceDirectionText": "Riley follows the route.",
        "fullDirectionText": "Riley follows the route.",
        "spokenDirectionText": "Follow the route.",
        "beforeGuidanceFields": {
          "directionText": "Riley follows the route.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c254",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "If there is one more opening behind that felt.",
        "sourceDirectionText": "Sam points to the fold.",
        "fullDirectionText": "Sam points to the fold.",
        "spokenDirectionText": "Point to the fold.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to the fold.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c255",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "We document first.",
        "sourceDirectionText": "Riley takes two photos.",
        "fullDirectionText": "Riley takes two photos.",
        "spokenDirectionText": "Take two photos.",
        "beforeGuidanceFields": {
          "directionText": "Riley takes two photos.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c256",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Then lift?",
        "sourceDirectionText": "Sam waits.",
        "fullDirectionText": "Sam waits.",
        "spokenDirectionText": "Wait.",
        "beforeGuidanceFields": {
          "directionText": "Sam waits.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c257",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Then lift.",
        "sourceDirectionText": "Riley uses a clean cloth to raise the felt edge.",
        "fullDirectionText": "Riley uses a clean cloth to raise the felt edge.",
        "spokenDirectionText": "Lift felt with cloth.",
        "beforeGuidanceFields": {
          "directionText": "Riley uses a clean cloth to raise the felt edge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c259",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "I see metal.",
        "sourceDirectionText": "Sam squints into the slot.",
        "fullDirectionText": "Sam squints into the slot.",
        "spokenDirectionText": "Squint into the slot.",
        "beforeGuidanceFields": {
          "directionText": "Sam squints into the slot.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c260",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Brass?",
        "sourceDirectionText": "Riley moves the light.",
        "fullDirectionText": "Riley moves the light.",
        "spokenDirectionText": "Move the light.",
        "beforeGuidanceFields": {
          "directionText": "Riley moves the light.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c261",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Brass.",
        "sourceDirectionText": "Sam smiles.",
        "fullDirectionText": "Sam smiles.",
        "spokenDirectionText": "Smile.",
        "beforeGuidanceFields": {
          "directionText": "Sam smiles.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c262",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Do not celebrate until it is out.",
        "sourceDirectionText": "Riley reaches for the prop handling gloves.",
        "fullDirectionText": "Riley reaches for the prop handling gloves.",
        "spokenDirectionText": "Reach for handling gloves.",
        "beforeGuidanceFields": {
          "directionText": "Riley reaches for the prop handling gloves.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c263",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Sensible and deeply boring.",
        "sourceDirectionText": "Sam puts on gloves too.",
        "fullDirectionText": "Sam puts on gloves too.",
        "spokenDirectionText": "Put on gloves too.",
        "beforeGuidanceFields": {
          "directionText": "Sam puts on gloves too.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c264",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "I will survive the insult.",
        "sourceDirectionText": "Riley checks the slot width.",
        "fullDirectionText": "Riley checks the slot width.",
        "spokenDirectionText": "Check the slot width.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the slot width.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c265",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Can we reach it?",
        "sourceDirectionText": "Sam measures with two fingers held outside the opening.",
        "fullDirectionText": "Sam measures with two fingers held outside the opening.",
        "spokenDirectionText": "Measure outside the opening.",
        "beforeGuidanceFields": {
          "directionText": "Sam measures with two fingers held outside the opening.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c266",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Not safely from here.",
        "sourceDirectionText": "Riley stops before forcing a hand into the slot.",
        "fullDirectionText": "Riley stops before forcing a hand into the slot.",
        "spokenDirectionText": "Stop before reaching inside.",
        "beforeGuidanceFields": {
          "directionText": "Riley stops before forcing a hand into the slot.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c267",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Another release?",
        "sourceDirectionText": "Sam looks around the base.",
        "fullDirectionText": "Sam looks around the base.",
        "spokenDirectionText": "Look around the base.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks around the base.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c268",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Look for hardware before we pull anything.",
        "sourceDirectionText": "Riley moves the light along the inner wall.",
        "fullDirectionText": "Riley moves the light along the inner wall.",
        "spokenDirectionText": "Move light along inner-wall.",
        "beforeGuidanceFields": {
          "directionText": "Riley moves the light along the inner wall.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c269",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Small metal plate. Back left.",
        "sourceDirectionText": "Sam points into the chamber.",
        "fullDirectionText": "Sam points into the chamber.",
        "spokenDirectionText": "Point into the chamber.",
        "beforeGuidanceFields": {
          "directionText": "Sam points into the chamber.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c270",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Magnetic?",
        "sourceDirectionText": "Riley looks at Sam's magnet.",
        "fullDirectionText": "Riley looks at Sam's magnet.",
        "spokenDirectionText": "Look at Sam's magnet.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks at Sam's magnet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c271",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Only one way to find out.",
        "sourceDirectionText": "Sam waits.",
        "fullDirectionText": "Sam waits.",
        "spokenDirectionText": "Wait.",
        "beforeGuidanceFields": {
          "directionText": "Sam waits.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c272",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Try it.",
        "sourceDirectionText": "Riley keeps the felt lifted.",
        "fullDirectionText": "Riley keeps the felt lifted.",
        "spokenDirectionText": "Keep the felt lifted.",
        "beforeGuidanceFields": {
          "directionText": "Riley keeps the felt lifted.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c273",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Moving in slowly.",
        "sourceDirectionText": "Sam brings the magnet near the back-left wall.",
        "fullDirectionText": "Sam brings the magnet near the back-left wall.",
        "spokenDirectionText": "Hover magnet, back-left wall.",
        "beforeGuidanceFields": {
          "directionText": "Sam brings the magnet near the back-left wall.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c275",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "There.",
        "sourceDirectionText": "Riley watches the slot widen.",
        "fullDirectionText": "Riley watches the slot widen.",
        "spokenDirectionText": "Watch the slot widen.",
        "beforeGuidanceFields": {
          "directionText": "Riley watches the slot widen.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c276",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Hidden door number three.",
        "sourceDirectionText": "Sam keeps the magnet in place.",
        "fullDirectionText": "Sam keeps the magnet in place.",
        "spokenDirectionText": "Hold magnet in place.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps the magnet in place.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c277",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "This cabinet has trust issues.",
        "sourceDirectionText": "Riley opens the inner flap carefully.",
        "fullDirectionText": "Riley opens the inner flap carefully.",
        "spokenDirectionText": "Open the inner flap.",
        "beforeGuidanceFields": {
          "directionText": "Riley opens the inner flap carefully.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c279",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Found.",
        "sourceDirectionText": "Sam exhales.",
        "fullDirectionText": "Sam exhales.",
        "spokenDirectionText": "Exhale.",
        "beforeGuidanceFields": {
          "directionText": "Sam exhales.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c280",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-4",
        "sourceDialogueText": "Found.",
        "sourceDirectionText": "Riley takes a photo before moving it.",
        "fullDirectionText": "Riley takes a photo before moving it.",
        "spokenDirectionText": "Photograph before moving.",
        "beforeGuidanceFields": {
          "directionText": "Riley takes a photo before moving it.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c281",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "No dents.",
        "sourceDirectionText": "Riley inspects the trophy from every side.",
        "fullDirectionText": "Riley inspects the trophy from every side.",
        "spokenDirectionText": "Inspect the trophy.",
        "beforeGuidanceFields": {
          "directionText": "Riley inspects the trophy from every side.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c282",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "No broken wings.",
        "sourceDirectionText": "Sam checks the raven shape without touching it.",
        "fullDirectionText": "Sam checks the raven shape without touching it.",
        "spokenDirectionText": "Examine raven without touching.",
        "beforeGuidanceFields": {
          "directionText": "Sam checks the raven shape without touching it.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c283",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "Base is clean.",
        "sourceDirectionText": "Riley looks underneath.",
        "fullDirectionText": "Riley looks underneath.",
        "spokenDirectionText": "Look underneath.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks underneath.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c284",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "Which means it did not bounce around much.",
        "sourceDirectionText": "Sam studies the padded ledge.",
        "fullDirectionText": "Sam studies the padded ledge.",
        "spokenDirectionText": "Study padded ledge.",
        "beforeGuidanceFields": {
          "directionText": "Sam studies the padded ledge.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c285",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "It dropped into a route built to move objects safely.",
        "sourceDirectionText": "Riley looks back through the hidden chambers.",
        "fullDirectionText": "Riley looks back through the hidden chambers.",
        "spokenDirectionText": "Look through hidden chambers.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks back through the hidden chambers.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c286",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "Merrick designed a very polite disappearance.",
        "sourceDirectionText": "Sam nods toward the cabinet.",
        "fullDirectionText": "Sam nods toward the cabinet.",
        "spokenDirectionText": "Nod toward the cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Sam nods toward the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c287",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "We still have to prove how it started.",
        "sourceDirectionText": "Riley keeps the raven in the open chamber.",
        "fullDirectionText": "Riley keeps the raven in the open chamber.",
        "spokenDirectionText": "Leave raven in chamber.",
        "beforeGuidanceFields": {
          "directionText": "Riley keeps the raven in the open chamber.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c288",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "Loose shelf plus cart bump.",
        "sourceDirectionText": "Sam points from shelf to impact mark.",
        "fullDirectionText": "Sam points from shelf to impact mark.",
        "spokenDirectionText": "Trace shelf to impact.",
        "beforeGuidanceFields": {
          "directionText": "Sam points from shelf to impact mark.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c289",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "That is our theory.",
        "sourceDirectionText": "Riley corrects him gently.",
        "fullDirectionText": "Riley corrects him gently.",
        "spokenDirectionText": "Correct gently.",
        "beforeGuidanceFields": {
          "directionText": "Riley corrects him gently.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c290",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "Right. Theory.",
        "sourceDirectionText": "Sam lifts both hands.",
        "fullDirectionText": "Sam lifts both hands.",
        "spokenDirectionText": "Lift both hands.",
        "beforeGuidanceFields": {
          "directionText": "Sam lifts both hands.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c291",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "I put the raven back. The shelf dipped. I pushed it level.",
        "sourceDirectionText": "Riley reconstructs the first step.",
        "fullDirectionText": "Riley reconstructs the first step.",
        "spokenDirectionText": "Reconstruct first step.",
        "beforeGuidanceFields": {
          "directionText": "Riley reconstructs the first step.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c292",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "Then the cart hit the cabinet later.",
        "sourceDirectionText": "Sam points to the gray mark.",
        "fullDirectionText": "Sam points to the gray mark.",
        "spokenDirectionText": "Point to gray mark.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to the gray mark.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c293",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "The bump could have released the shelf again.",
        "sourceDirectionText": "Riley presses the shelf without completing the motion.",
        "fullDirectionText": "Riley presses the shelf without completing the motion.",
        "spokenDirectionText": "Press shelf; stop short.",
        "beforeGuidanceFields": {
          "directionText": "Riley presses the shelf without completing the motion.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c294",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "And the trophy could slide into the first hidden path.",
        "sourceDirectionText": "Sam points to the upper compartment.",
        "fullDirectionText": "Sam points to the upper compartment.",
        "spokenDirectionText": "Point to upper compartment.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to the upper compartment.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c295",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "Then down to the lower chamber.",
        "sourceDirectionText": "Riley points to the curved scuff.",
        "fullDirectionText": "Riley points to the curved scuff.",
        "spokenDirectionText": "Point to curved scuff.",
        "beforeGuidanceFields": {
          "directionText": "Riley points to the curved scuff.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c296",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "Then into the padded load slot.",
        "sourceDirectionText": "Sam points to the raven.",
        "fullDirectionText": "Sam points to the raven.",
        "spokenDirectionText": "Point to the raven.",
        "beforeGuidanceFields": {
          "directionText": "Sam points to the raven.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c297",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "It fits every clue we have.",
        "sourceDirectionText": "Riley checks the clue list.",
        "fullDirectionText": "Riley checks the clue list.",
        "spokenDirectionText": "Check the clue list.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the clue list.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c298",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "Which is good.",
        "sourceDirectionText": "Sam starts to smile.",
        "fullDirectionText": "Sam starts to smile.",
        "spokenDirectionText": "Begin to smile.",
        "beforeGuidanceFields": {
          "directionText": "Sam starts to smile.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c299",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "It is not proof yet.",
        "sourceDirectionText": "Riley gives Sam a look.",
        "fullDirectionText": "Riley gives Sam a look.",
        "spokenDirectionText": "Give Sam a look.",
        "beforeGuidanceFields": {
          "directionText": "Riley gives Sam a look.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c300",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-5",
        "sourceDialogueText": "You are going to make the cabinet do it again.",
        "sourceDirectionText": "Sam already knows the answer.",
        "fullDirectionText": "Sam already knows the answer.",
        "spokenDirectionText": "Already know the answer.",
        "beforeGuidanceFields": {
          "directionText": "Sam already knows the answer.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c301",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "With a practice block, not the raven.",
        "sourceDirectionText": "Riley picks up a light wooden prop block.",
        "fullDirectionText": "Riley picks up a light wooden prop block.",
        "spokenDirectionText": "Pick up wooden block.",
        "beforeGuidanceFields": {
          "directionText": "Riley picks up a light wooden prop block.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c302",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Same size?",
        "sourceDirectionText": "Sam compares the block to the trophy base.",
        "fullDirectionText": "Sam compares the block to the trophy base.",
        "spokenDirectionText": "Compare block to trophy-base.",
        "beforeGuidanceFields": {
          "directionText": "Sam compares the block to the trophy base.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c303",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Close enough to test the path without risking anything valuable.",
        "sourceDirectionText": "Riley measures it against the dust ring.",
        "fullDirectionText": "Riley measures it against the dust ring.",
        "spokenDirectionText": "Compare with dust ring.",
        "beforeGuidanceFields": {
          "directionText": "Riley measures it against the dust ring.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c304",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "I like this version of reckless.",
        "sourceDirectionText": "Sam moves the raven to a padded tray.",
        "fullDirectionText": "Sam moves the raven to a padded tray.",
        "spokenDirectionText": "Move raven to padded-tray.",
        "beforeGuidanceFields": {
          "directionText": "Sam moves the raven to a padded tray.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c305",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Put the raven out of the cabinet completely.",
        "sourceDirectionText": "Riley waits until Sam does.",
        "fullDirectionText": "Riley waits until Sam does.",
        "spokenDirectionText": "Wait for Sam.",
        "beforeGuidanceFields": {
          "directionText": "Riley waits until Sam does.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c306",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Safe.",
        "sourceDirectionText": "Sam sets the raven on the tray away from the work area.",
        "fullDirectionText": "Sam sets the raven on the tray away from the work area.",
        "spokenDirectionText": "Set raven on distant-tray.",
        "beforeGuidanceFields": {
          "directionText": "Sam sets the raven on the tray away from the work area.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c307",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Practice block on the original spot.",
        "sourceDirectionText": "Riley places it on the loose shelf.",
        "fullDirectionText": "Riley places it on the loose shelf.",
        "spokenDirectionText": "Place block on shelf.",
        "beforeGuidanceFields": {
          "directionText": "Riley places it on the loose shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c308",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "I am watching the lower seam.",
        "sourceDirectionText": "Sam crouches by the base.",
        "fullDirectionText": "Sam crouches by the base.",
        "spokenDirectionText": "Crouch by the base.",
        "beforeGuidanceFields": {
          "directionText": "Sam crouches by the base.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c309",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "I will recreate the shelf dip first, then a gentle bump at the impact point.",
        "sourceDirectionText": "Riley explains the test before moving anything.",
        "fullDirectionText": "Riley explains the test before moving anything.",
        "spokenDirectionText": "Explain before testing.",
        "beforeGuidanceFields": {
          "directionText": "Riley explains the test before moving anything.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c310",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Recorded.",
        "sourceDirectionText": "Sam starts the phone video.",
        "fullDirectionText": "Sam starts the phone video.",
        "spokenDirectionText": "Start the phone video.",
        "beforeGuidanceFields": {
          "directionText": "Sam starts the phone video.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c311",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Shelf first. No bump yet.",
        "sourceDirectionText": "Riley checks the camera and keeps one hand near the practice block.",
        "fullDirectionText": "Riley checks the camera and keeps one hand near the practice block.",
        "spokenDirectionText": "Check camera position.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the camera and keeps one hand near the practice block.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c312",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Camera is rolling.",
        "sourceDirectionText": "Sam frames the shelf and lower cabinet in one shot.",
        "fullDirectionText": "Sam frames the shelf and lower cabinet in one shot.",
        "spokenDirectionText": "Frame shelf and cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Sam frames the shelf and lower cabinet in one shot.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c313",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "I am lowering the back edge about the same amount as before.",
        "sourceDirectionText": "Riley eases the shelf down a quarter inch.",
        "fullDirectionText": "Riley eases the shelf down a quarter inch.",
        "spokenDirectionText": "Lower shelf slightly.",
        "beforeGuidanceFields": {
          "directionText": "Riley eases the shelf down a quarter inch.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c315",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "It moved, but it stayed.",
        "sourceDirectionText": "Sam keeps the camera steady.",
        "fullDirectionText": "Sam keeps the camera steady.",
        "spokenDirectionText": "Keep the camera steady.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps the camera steady.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c316",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Good. The loose shelf alone is not enough.",
        "sourceDirectionText": "Riley resets the shelf.",
        "fullDirectionText": "Riley resets the shelf.",
        "spokenDirectionText": "Reset the shelf.",
        "beforeGuidanceFields": {
          "directionText": "Riley resets the shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c317",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "So the bump matters.",
        "sourceDirectionText": "Sam glances toward the rehearsal cart.",
        "fullDirectionText": "Sam glances toward the rehearsal cart.",
        "spokenDirectionText": "Glance toward rehearsal cart.",
        "beforeGuidanceFields": {
          "directionText": "Sam glances toward the rehearsal cart.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c318",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Or we are recreating it wrong.",
        "sourceDirectionText": "Riley checks the impact mark again.",
        "fullDirectionText": "Riley checks the impact mark again.",
        "spokenDirectionText": "Check the impact mark.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the impact mark again.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c319",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Same side, same height, same cart.",
        "sourceDirectionText": "Sam lines up the caster with the gray mark.",
        "fullDirectionText": "Sam lines up the caster with the gray mark.",
        "spokenDirectionText": "Align caster and mark.",
        "beforeGuidanceFields": {
          "directionText": "Sam lines up the caster with the gray mark.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c320",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "We protect the cabinet first.",
        "sourceDirectionText": "Riley folds a stage mat over the impact point.",
        "fullDirectionText": "Riley folds a stage mat over the impact point.",
        "spokenDirectionText": "Pad the impact point.",
        "beforeGuidanceFields": {
          "directionText": "Riley folds a stage mat over the impact point.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c321",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Very responsible. Very little mystery-movie energy.",
        "sourceDirectionText": "Sam holds the cart still.",
        "fullDirectionText": "Sam holds the cart still.",
        "spokenDirectionText": "Hold the cart still.",
        "beforeGuidanceFields": {
          "directionText": "Sam holds the cart still.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c322",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "This is evidence, not an encore.",
        "sourceDirectionText": "Riley puts the practice block back on the shelf.",
        "fullDirectionText": "Riley puts the practice block back on the shelf.",
        "spokenDirectionText": "Return block to shelf.",
        "beforeGuidanceFields": {
          "directionText": "Riley puts the practice block back on the shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c323",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Fair.",
        "sourceDirectionText": "Sam braces the cart so it cannot roll early.",
        "fullDirectionText": "Sam braces the cart so it cannot roll early.",
        "spokenDirectionText": "Brace the cart.",
        "beforeGuidanceFields": {
          "directionText": "Sam braces the cart so it cannot roll early.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c324",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Bring it forward until the caster just touches the mat.",
        "sourceDirectionText": "Riley watches the shelf.",
        "fullDirectionText": "Riley watches the shelf.",
        "spokenDirectionText": "Watch the shelf.",
        "beforeGuidanceFields": {
          "directionText": "Riley watches the shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c325",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Moving.",
        "sourceDirectionText": "Sam rolls the cart slowly.",
        "fullDirectionText": "Sam rolls the cart slowly.",
        "spokenDirectionText": "Roll the cart slowly.",
        "beforeGuidanceFields": {
          "directionText": "Sam rolls the cart slowly.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c326",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Stop.",
        "sourceDirectionText": "Riley raises one hand.",
        "fullDirectionText": "Riley raises one hand.",
        "spokenDirectionText": "Raise one hand.",
        "beforeGuidanceFields": {
          "directionText": "Riley raises one hand.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c327",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Contact.",
        "sourceDirectionText": "Sam freezes the cart.",
        "fullDirectionText": "Sam freezes the cart.",
        "spokenDirectionText": "Freeze the cart.",
        "beforeGuidanceFields": {
          "directionText": "Sam freezes the cart.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c328",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Nothing yet.",
        "sourceDirectionText": "Riley checks the shelf and block.",
        "fullDirectionText": "Riley checks the shelf and block.",
        "spokenDirectionText": "Check shelf and block.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the shelf and block.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c329",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Then give it the smallest bump you can.",
        "sourceDirectionText": "Sam keeps both hands on the cart.",
        "fullDirectionText": "Sam keeps both hands on the cart.",
        "spokenDirectionText": "Keep hands on cart.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps both hands on the cart.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c330",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "One inch. No more.",
        "sourceDirectionText": "Riley points to the floor and watches closely.",
        "fullDirectionText": "Riley points to the floor and watches closely.",
        "spokenDirectionText": "Point to the floor.",
        "beforeGuidanceFields": {
          "directionText": "Riley points to the floor and watches closely.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c332",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "There it goes.",
        "sourceDirectionText": "Sam keeps filming.",
        "fullDirectionText": "Sam keeps filming.",
        "spokenDirectionText": "Keep filming.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps filming.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c334",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Do not touch anything.",
        "sourceDirectionText": "Riley listens.",
        "fullDirectionText": "Riley listens.",
        "spokenDirectionText": "Listen.",
        "beforeGuidanceFields": {
          "directionText": "Riley listens.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c336",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Same sound as before.",
        "sourceDirectionText": "Sam lowers the camera toward the chamber.",
        "fullDirectionText": "Sam lowers the camera toward the chamber.",
        "spokenDirectionText": "Lower camera toward chamber.",
        "beforeGuidanceFields": {
          "directionText": "Sam lowers the camera toward the chamber.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c337",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Open the service panel with the magnet.",
        "sourceDirectionText": "Riley stays clear of the cabinet.",
        "fullDirectionText": "Riley stays clear of the cabinet.",
        "spokenDirectionText": "Stay clear of cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Riley stays clear of the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c338",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Magnet in.",
        "sourceDirectionText": "Sam brings the magnet near the known release point.",
        "fullDirectionText": "Sam brings the magnet near the known release point.",
        "spokenDirectionText": "Position magnet near release-point.",
        "beforeGuidanceFields": {
          "directionText": "Sam brings the magnet near the known release point.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c340",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "That is proof.",
        "sourceDirectionText": "Riley finally lets out the breath Riley has been holding.",
        "fullDirectionText": "Riley finally lets out the breath Riley has been holding.",
        "spokenDirectionText": "Finally exhale.",
        "beforeGuidanceFields": {
          "directionText": "Riley finally lets out the breath Riley has been holding.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c341",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Loose shelf, small impact, hidden route.",
        "sourceDirectionText": "Sam points from the shelf to the block.",
        "fullDirectionText": "Sam points from the shelf to the block.",
        "spokenDirectionText": "Trace shelf to block.",
        "beforeGuidanceFields": {
          "directionText": "Sam points from the shelf to the block.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c342",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "And the block made the same trip without either of us pushing it into the opening.",
        "sourceDirectionText": "Riley checks the video.",
        "fullDirectionText": "Riley checks the video.",
        "spokenDirectionText": "Check the video.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the video.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c343",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Want to run it again?",
        "sourceDirectionText": "Sam reaches toward the cart handle, then waits.",
        "fullDirectionText": "Sam reaches toward the cart handle, then waits.",
        "spokenDirectionText": "Reach for handle; wait.",
        "beforeGuidanceFields": {
          "directionText": "Sam reaches toward the cart handle, then waits.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c344",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "No. One clean test is enough.",
        "sourceDirectionText": "Riley stops the second test before it starts.",
        "fullDirectionText": "Riley stops the second test before it starts.",
        "spokenDirectionText": "Stop test before starting.",
        "beforeGuidanceFields": {
          "directionText": "Riley stops the second test before it starts.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c345",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "I respect a mystery that knows when to quit.",
        "sourceDirectionText": "Sam rolls the cart back from the cabinet.",
        "fullDirectionText": "Sam rolls the cart back from the cabinet.",
        "spokenDirectionText": "Roll cart back away.",
        "beforeGuidanceFields": {
          "directionText": "Sam rolls the cart back from the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c346",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "The raven is safe. The path is proven.",
        "sourceDirectionText": "Riley looks at the padded tray.",
        "fullDirectionText": "Riley looks at the padded tray.",
        "spokenDirectionText": "Look at padded tray.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks at the padded tray.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c347",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Then we are done.",
        "sourceDirectionText": "Sam smiles.",
        "fullDirectionText": "Sam smiles.",
        "spokenDirectionText": "Smile.",
        "beforeGuidanceFields": {
          "directionText": "Sam smiles.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c348",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Almost.",
        "sourceDirectionText": "Riley's smile fades as Riley looks at the phone.",
        "fullDirectionText": "Riley's smile fades as Riley looks at the phone.",
        "spokenDirectionText": "Let your smile fade.",
        "beforeGuidanceFields": {
          "directionText": "Riley's smile fades as Riley looks at the phone.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c349",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "What is left?",
        "sourceDirectionText": "Sam follows Riley's look.",
        "fullDirectionText": "Sam follows Riley's look.",
        "spokenDirectionText": "Follow Riley's look.",
        "beforeGuidanceFields": {
          "directionText": "Sam follows Riley's look.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c350",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-6",
        "sourceDialogueText": "Telling the director exactly what happened.",
        "sourceDirectionText": "Riley turns the phone over in one hand.",
        "fullDirectionText": "Riley turns the phone over in one hand.",
        "spokenDirectionText": "Flip phone over.",
        "beforeGuidanceFields": {
          "directionText": "Riley turns the phone over in one hand.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c351",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "We found it. That part should help.",
        "sourceDirectionText": "Sam keeps his voice light.",
        "fullDirectionText": "Sam keeps his voice light.",
        "spokenDirectionText": "Keep your voice light.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps his voice light.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c352",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "I could put the raven back and say we found it inside the cabinet.",
        "sourceDirectionText": "Riley looks at the empty display shelf.",
        "fullDirectionText": "Riley looks at the empty display shelf.",
        "spokenDirectionText": "Look at empty shelf.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks at the empty display shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c353",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "You could.",
        "sourceDirectionText": "Sam does not move toward the trophy.",
        "fullDirectionText": "Sam does not move toward the trophy.",
        "spokenDirectionText": "Don't approach the trophy.",
        "beforeGuidanceFields": {
          "directionText": "Sam does not move toward the trophy.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c354",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "That would even be true.",
        "sourceDirectionText": "Riley tests the sentence out loud.",
        "fullDirectionText": "Riley tests the sentence out loud.",
        "spokenDirectionText": "Test the sentence out.",
        "beforeGuidanceFields": {
          "directionText": "Riley tests the sentence out loud.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c355",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "Part of it would be.",
        "sourceDirectionText": "Sam waits.",
        "fullDirectionText": "Sam waits.",
        "spokenDirectionText": "Wait.",
        "beforeGuidanceFields": {
          "directionText": "Sam waits.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c356",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "I hate that answer.",
        "sourceDirectionText": "Riley looks down at the phone.",
        "fullDirectionText": "Riley looks down at the phone.",
        "spokenDirectionText": "Look down at phone.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks down at the phone.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c357",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "You wanted the honest one.",
        "sourceDirectionText": "Sam gives Riley room.",
        "fullDirectionText": "Sam gives Riley room.",
        "spokenDirectionText": "Give Riley some room.",
        "beforeGuidanceFields": {
          "directionText": "Sam gives Riley room.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c358",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "The shelf felt loose, and I left it.",
        "sourceDirectionText": "Riley says the part Riley least wants to report.",
        "fullDirectionText": "Riley says the part Riley least wants to report.",
        "spokenDirectionText": "Admit the difficult part.",
        "beforeGuidanceFields": {
          "directionText": "Riley says the part Riley least wants to report.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c359",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "Yes.",
        "sourceDirectionText": "Sam stays quiet after the answer.",
        "fullDirectionText": "Sam stays quiet after the answer.",
        "spokenDirectionText": "Stay quiet afterward.",
        "beforeGuidanceFields": {
          "directionText": "Sam stays quiet after the answer.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c360",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "I was busy. Places had been called. Everybody needed something.",
        "sourceDirectionText": "Riley starts to defend it, then stops.",
        "fullDirectionText": "Riley starts to defend it, then stops.",
        "spokenDirectionText": "Start defending, then stop.",
        "beforeGuidanceFields": {
          "directionText": "Riley starts to defend it, then stops.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c361",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "All true.",
        "sourceDirectionText": "Sam nods once.",
        "fullDirectionText": "Sam nods once.",
        "spokenDirectionText": "Nod once.",
        "beforeGuidanceFields": {
          "directionText": "Sam nods once.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c362",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "Still does not change the shelf.",
        "sourceDirectionText": "Riley looks back at the cabinet.",
        "fullDirectionText": "Riley looks back at the cabinet.",
        "spokenDirectionText": "Look back at cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks back at the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c363",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "No.",
        "sourceDirectionText": "Sam keeps the answer simple.",
        "fullDirectionText": "Sam keeps the answer simple.",
        "spokenDirectionText": "Keep the answer simple.",
        "beforeGuidanceFields": {
          "directionText": "Sam keeps the answer simple.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c364",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "You are extremely unhelpful when you agree with me.",
        "sourceDirectionText": "Riley exhales.",
        "fullDirectionText": "Riley exhales.",
        "spokenDirectionText": "Exhale.",
        "beforeGuidanceFields": {
          "directionText": "Riley exhales.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c365",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "I can disagree if it would improve morale.",
        "sourceDirectionText": "Sam offers the joke without pushing it.",
        "fullDirectionText": "Sam offers the joke without pushing it.",
        "spokenDirectionText": "Offer a gentle joke.",
        "beforeGuidanceFields": {
          "directionText": "Sam offers the joke without pushing it.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c366",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "It would not.",
        "sourceDirectionText": "Riley unlocks the phone.",
        "fullDirectionText": "Riley unlocks the phone.",
        "spokenDirectionText": "Unlock the phone.",
        "beforeGuidanceFields": {
          "directionText": "Riley unlocks the phone.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c367",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "Then what are you going to say?",
        "sourceDirectionText": "Sam steps back.",
        "fullDirectionText": "Sam steps back.",
        "spokenDirectionText": "Step back.",
        "beforeGuidanceFields": {
          "directionText": "Sam steps back.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c368",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "All of it.",
        "sourceDirectionText": "Riley opens the director's contact.",
        "fullDirectionText": "Riley opens the director's contact.",
        "spokenDirectionText": "Open the director's contact.",
        "beforeGuidanceFields": {
          "directionText": "Riley opens the director's contact.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c369",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "Before she gets back?",
        "sourceDirectionText": "Sam checks the clock.",
        "fullDirectionText": "Sam checks the clock.",
        "spokenDirectionText": "Check the clock.",
        "beforeGuidanceFields": {
          "directionText": "Sam checks the clock.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c370",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "Before I can talk myself out of it.",
        "sourceDirectionText": "Riley starts the call.",
        "fullDirectionText": "Riley starts the call.",
        "spokenDirectionText": "Start the call.",
        "beforeGuidanceFields": {
          "directionText": "Riley starts the call.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c371",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "Hi. It is Riley. We found the raven.",
        "sourceDirectionText": "Riley speaks into the phone.",
        "fullDirectionText": "Riley speaks into the phone.",
        "spokenDirectionText": "Speak into phone.",
        "beforeGuidanceFields": {
          "directionText": "Riley speaks into the phone.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c372",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "No, it was not stolen.",
        "sourceDirectionText": "Riley listens, then looks at the cabinet.",
        "fullDirectionText": "Riley listens, then looks at the cabinet.",
        "spokenDirectionText": "Listen.",
        "beforeGuidanceFields": {
          "directionText": "Riley listens, then looks at the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c373",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "It fell into a hidden trick path inside the old display cabinet.",
        "sourceDirectionText": "Riley keeps the explanation plain.",
        "fullDirectionText": "Riley keeps the explanation plain.",
        "spokenDirectionText": "Keep the explanation plain.",
        "beforeGuidanceFields": {
          "directionText": "Riley keeps the explanation plain.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c374",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "I need to tell you the part that was mine.",
        "sourceDirectionText": "Riley glances at Sam, then keeps going.",
        "fullDirectionText": "Riley glances at Sam, then keeps going.",
        "spokenDirectionText": "Glance at Sam.",
        "beforeGuidanceFields": {
          "directionText": "Riley glances at Sam, then keeps going.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c375",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "The shelf felt loose when I put the trophy back. I meant to check it, and I did not.",
        "sourceDirectionText": "Riley does not soften the sentence.",
        "fullDirectionText": "Riley does not soften the sentence.",
        "spokenDirectionText": "Speak without softening.",
        "beforeGuidanceFields": {
          "directionText": "Riley does not soften the sentence.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c376",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "The rehearsal cart bumped the cabinet later.",
        "sourceDirectionText": "Riley points to the impact mark.",
        "fullDirectionText": "Riley points to the impact mark.",
        "spokenDirectionText": "Point to impact mark.",
        "beforeGuidanceFields": {
          "directionText": "Riley points to the impact mark.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c377",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "We tested the same setup with a wood block and filmed it.",
        "sourceDirectionText": "Riley opens the proof video.",
        "fullDirectionText": "Riley opens the proof video.",
        "spokenDirectionText": "Open the proof video.",
        "beforeGuidanceFields": {
          "directionText": "Riley opens the proof video.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c378",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "The raven is undamaged.",
        "sourceDirectionText": "Riley looks at the trophy on the padded tray.",
        "fullDirectionText": "Riley looks at the trophy on the padded tray.",
        "spokenDirectionText": "Look at the trophy.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks at the trophy on the padded tray.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c379",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "The cabinet should not be used again until someone repairs it.",
        "sourceDirectionText": "Riley looks at the loose shelf.",
        "fullDirectionText": "Riley looks at the loose shelf.",
        "spokenDirectionText": "Look at loose shelf.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks at the loose shelf.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c380",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "Yes. We have photos too.",
        "sourceDirectionText": "Riley checks the clue folder.",
        "fullDirectionText": "Riley checks the clue folder.",
        "spokenDirectionText": "Check the clue folder.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the clue folder.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c381",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "Okay. We will stay here.",
        "sourceDirectionText": "Riley listens one more time.",
        "fullDirectionText": "Riley listens one more time.",
        "spokenDirectionText": "Listen one more time.",
        "beforeGuidanceFields": {
          "directionText": "Riley listens one more time.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c382",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "Thank you.",
        "sourceDirectionText": "Riley ends the call.",
        "fullDirectionText": "Riley ends the call.",
        "spokenDirectionText": "End the call.",
        "beforeGuidanceFields": {
          "directionText": "Riley ends the call.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c383",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "How bad?",
        "sourceDirectionText": "Sam waits for Riley's face to answer first.",
        "fullDirectionText": "Sam waits for Riley's face to answer first.",
        "spokenDirectionText": "Watch Riley’s face.",
        "beforeGuidanceFields": {
          "directionText": "Sam waits for Riley's face to answer first.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c384",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "She said thank you for calling before she walked into a surprise.",
        "sourceDirectionText": "Riley puts the phone away.",
        "fullDirectionText": "Riley puts the phone away.",
        "spokenDirectionText": "Put the phone away.",
        "beforeGuidanceFields": {
          "directionText": "Riley puts the phone away.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c385",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "That sounds less bad than your face predicted.",
        "sourceDirectionText": "Sam relaxes.",
        "fullDirectionText": "Sam relaxes.",
        "spokenDirectionText": "Relax.",
        "beforeGuidanceFields": {
          "directionText": "Sam relaxes.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c386",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "She also said nobody touches this cabinet again until it is inspected.",
        "sourceDirectionText": "Riley points at Sam's hand.",
        "fullDirectionText": "Riley points at Sam's hand.",
        "spokenDirectionText": "Point at Sam's hand.",
        "beforeGuidanceFields": {
          "directionText": "Riley points at Sam's hand.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c387",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "I was only thinking about touching it.",
        "sourceDirectionText": "Sam slowly pulls his hand back.",
        "fullDirectionText": "Sam slowly pulls his hand back.",
        "spokenDirectionText": "Pull your hand back.",
        "beforeGuidanceFields": {
          "directionText": "Sam slowly pulls his hand back.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c388",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "Your hand was moving.",
        "sourceDirectionText": "Riley gives Sam a look.",
        "fullDirectionText": "Riley gives Sam a look.",
        "spokenDirectionText": "Give Sam a look.",
        "beforeGuidanceFields": {
          "directionText": "Riley gives Sam a look.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c389",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "My hand thinks faster than I do.",
        "sourceDirectionText": "Sam folds both arms.",
        "fullDirectionText": "Sam folds both arms.",
        "spokenDirectionText": "Fold both arms.",
        "beforeGuidanceFields": {
          "directionText": "Sam folds both arms.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c390",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-7",
        "sourceDialogueText": "That explains a lot.",
        "sourceDirectionText": "Riley finally laughs.",
        "fullDirectionText": "Riley finally laughs.",
        "spokenDirectionText": "Laugh at last.",
        "beforeGuidanceFields": {
          "directionText": "Riley finally laughs.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c391",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "She wants the raven in the prop safe and this whole cabinet marked out of use.",
        "sourceDirectionText": "Riley reads the message that follows the call.",
        "fullDirectionText": "Riley reads the message that follows the call.",
        "spokenDirectionText": "Read the new message.",
        "beforeGuidanceFields": {
          "directionText": "Riley reads the message that follows the call.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c392",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "I can carry the tray.",
        "sourceDirectionText": "Sam steps beside the raven.",
        "fullDirectionText": "Sam steps beside the raven.",
        "spokenDirectionText": "Step beside the raven.",
        "beforeGuidanceFields": {
          "directionText": "Sam steps beside the raven.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c393",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Together.",
        "sourceDirectionText": "Riley takes the other side.",
        "fullDirectionText": "Riley takes the other side.",
        "spokenDirectionText": "Take the other side.",
        "beforeGuidanceFields": {
          "directionText": "Riley takes the other side.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c395",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Strange ending for a trophy we spent all night trying to put back.",
        "sourceDirectionText": "Sam waits while Riley opens the safe.",
        "fullDirectionText": "Sam waits while Riley opens the safe.",
        "spokenDirectionText": "Wait beside the safe.",
        "beforeGuidanceFields": {
          "directionText": "Sam waits while Riley opens the safe.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c396",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Safer ending.",
        "sourceDirectionText": "Riley places the raven inside.",
        "fullDirectionText": "Riley places the raven inside.",
        "spokenDirectionText": "Place the raven inside.",
        "beforeGuidanceFields": {
          "directionText": "Riley places the raven inside.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c397",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Fair.",
        "sourceDirectionText": "Sam watches Riley lock the safe.",
        "fullDirectionText": "Sam watches Riley lock the safe.",
        "spokenDirectionText": "Watch Riley lock safe.",
        "beforeGuidanceFields": {
          "directionText": "Sam watches Riley lock the safe.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c398",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Logged. Brass raven moved to prop safe pending cabinet repair.",
        "sourceDirectionText": "Riley enters the location in the inventory.",
        "fullDirectionText": "Riley enters the location in the inventory.",
        "spokenDirectionText": "Enter inventory location.",
        "beforeGuidanceFields": {
          "directionText": "Riley enters the location in the inventory.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c399",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Now the warning sign.",
        "sourceDirectionText": "Sam reaches for a blank stage notice.",
        "fullDirectionText": "Sam reaches for a blank stage notice.",
        "spokenDirectionText": "Reach for blank notice.",
        "beforeGuidanceFields": {
          "directionText": "Sam reaches for a blank stage notice.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c400",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Put it on the stand, not the cabinet.",
        "sourceDirectionText": "Riley points to a music stand beside it.",
        "fullDirectionText": "Riley points to a music stand beside it.",
        "spokenDirectionText": "Point at music stand.",
        "beforeGuidanceFields": {
          "directionText": "Riley points to a music stand beside it.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c401",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "\"Do not use. Hidden mechanism needs inspection.\"",
        "sourceDirectionText": "Sam writes the first line.",
        "fullDirectionText": "Sam writes the first line.",
        "spokenDirectionText": "Write the first line.",
        "beforeGuidanceFields": {
          "directionText": "Sam writes the first line.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c402",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Add loose shelf.",
        "sourceDirectionText": "Riley checks the cabinet without touching it.",
        "fullDirectionText": "Riley checks the cabinet without touching it.",
        "spokenDirectionText": "Inspect without touching.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the cabinet without touching it.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c403",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "And cart impact?",
        "sourceDirectionText": "Sam looks at the mark near the base.",
        "fullDirectionText": "Sam looks at the mark near the base.",
        "spokenDirectionText": "Inspect mark near base.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks at the mark near the base.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c404",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Put that in the report. The sign just needs to stop people from using it.",
        "sourceDirectionText": "Riley keeps the warning simple.",
        "fullDirectionText": "Riley keeps the warning simple.",
        "spokenDirectionText": "Keep the warning simple.",
        "beforeGuidanceFields": {
          "directionText": "Riley keeps the warning simple.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c405",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Good. I was running out of marker.",
        "sourceDirectionText": "Sam caps it.",
        "fullDirectionText": "Sam caps it.",
        "spokenDirectionText": "Cap it.",
        "beforeGuidanceFields": {
          "directionText": "Sam caps it.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c406",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Leave the panels exactly where they are.",
        "sourceDirectionText": "Riley photographs the open service sections.",
        "fullDirectionText": "Riley photographs the open service sections.",
        "spokenDirectionText": "Photograph service openings.",
        "beforeGuidanceFields": {
          "directionText": "Riley photographs the open service sections.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c407",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "So the repair person can see the route.",
        "sourceDirectionText": "Sam steps away from the cabinet.",
        "fullDirectionText": "Sam steps away from the cabinet.",
        "spokenDirectionText": "Step away.",
        "beforeGuidanceFields": {
          "directionText": "Sam steps away from the cabinet.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c408",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "And so nobody forces a panel shut.",
        "sourceDirectionText": "Riley moves the warning stand in front.",
        "fullDirectionText": "Riley moves the warning stand in front.",
        "spokenDirectionText": "Place stand before cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Riley moves the warning stand in front.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c409",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "What about the cart?",
        "sourceDirectionText": "Sam looks at the rear caster.",
        "fullDirectionText": "Sam looks at the rear caster.",
        "spokenDirectionText": "Check rear caster.",
        "beforeGuidanceFields": {
          "directionText": "Sam looks at the rear caster.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c410",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Move it out of the aisle and check that wheel.",
        "sourceDirectionText": "Riley points to the wide-swinging caster.",
        "fullDirectionText": "Riley points to the wide-swinging caster.",
        "spokenDirectionText": "Point at wide-swinging caster.",
        "beforeGuidanceFields": {
          "directionText": "Riley points to the wide-swinging caster.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c411",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "It swings farther than the others.",
        "sourceDirectionText": "Sam turns the cart slowly.",
        "fullDirectionText": "Sam turns the cart slowly.",
        "spokenDirectionText": "Turn the cart slowly.",
        "beforeGuidanceFields": {
          "directionText": "Sam turns the cart slowly.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c412",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-8",
        "sourceDialogueText": "Then that goes in the report too.",
        "sourceDirectionText": "Riley photographs the caster.",
        "fullDirectionText": "Riley photographs the caster.",
        "spokenDirectionText": "Photograph the caster.",
        "beforeGuidanceFields": {
          "directionText": "Riley photographs the caster.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c413",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-9",
        "sourceDialogueText": "The cabinet is not responsible for everything after all.",
        "sourceDirectionText": "Sam nudges the cart away.",
        "fullDirectionText": "Sam nudges the cart away.",
        "spokenDirectionText": "Nudge the cart away.",
        "beforeGuidanceFields": {
          "directionText": "Sam nudges the cart away.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c414",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-9",
        "sourceDialogueText": "Do not start defending it.",
        "sourceDirectionText": "Riley checks the cleared aisle.",
        "fullDirectionText": "Riley checks the cleared aisle.",
        "spokenDirectionText": "Check the cleared aisle.",
        "beforeGuidanceFields": {
          "directionText": "Riley checks the cleared aisle.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c415",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-9",
        "sourceDialogueText": "I respect competent machinery.",
        "sourceDirectionText": "Sam parks the cart.",
        "fullDirectionText": "Sam parks the cart.",
        "spokenDirectionText": "Park the cart.",
        "beforeGuidanceFields": {
          "directionText": "Sam parks the cart.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c416",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-9",
        "sourceDialogueText": "You respect anything with a secret compartment.",
        "sourceDirectionText": "Riley closes the inventory screen.",
        "fullDirectionText": "Riley closes the inventory screen.",
        "spokenDirectionText": "Close the inventory screen.",
        "beforeGuidanceFields": {
          "directionText": "Riley closes the inventory screen.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c417",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-9",
        "sourceDialogueText": "Also true.",
        "sourceDirectionText": "Sam returns to the cabinet area.",
        "fullDirectionText": "Sam returns to the cabinet area.",
        "spokenDirectionText": "Return to the cabinet.",
        "beforeGuidanceFields": {
          "directionText": "Sam returns to the cabinet area.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c418",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-9",
        "sourceDialogueText": "Clear path, warning sign, raven secured, proof saved.",
        "sourceDirectionText": "Riley looks around the room.",
        "fullDirectionText": "Riley looks around the room.",
        "spokenDirectionText": "Look around the room.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks around the room.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c419",
        "characterId": "sam",
        "sceneId": "raven-expanded-scene-9",
        "sourceDialogueText": "That sounds like a stage manager again.",
        "sourceDirectionText": "Sam smiles.",
        "fullDirectionText": "Sam smiles.",
        "spokenDirectionText": "Smile.",
        "beforeGuidanceFields": {
          "directionText": "Sam smiles.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      },
      {
        "cueId": "raven-expanded-c420",
        "characterId": "riley",
        "sceneId": "raven-expanded-scene-9",
        "sourceDialogueText": "A stage manager who is never ignoring a loose shelf again.",
        "sourceDirectionText": "Riley looks once at the cabinet, then heads for the door.",
        "fullDirectionText": "Riley looks once at the cabinet, then heads for the door.",
        "spokenDirectionText": "Look back; then leave.",
        "beforeGuidanceFields": {
          "directionText": "Riley looks once at the cabinet, then heads for the door.",
          "spokenDirectionPending": true,
          "directionCaptionOnly": true
        }
      }
    ]
  }
};
